import {
  Box3,
  BoxGeometry,
  BoxHelper,
  BufferGeometry,
  CanvasTexture,
  ClampToEdgeWrapping,
  Color,
  CubeReflectionMapping,
  CubeTextureLoader,
  CylinderGeometry,
  ExtrudeGeometry,
  Group,
  Material,
  Matrix4,
  Mesh,
  MeshBasicMaterial,
  MeshNormalMaterial,
  MeshPhysicalMaterial,
  MeshStandardMaterial,
  Object3D,
  PlaneGeometry,
  RepeatWrapping,
  RGBFormat,
  ShaderMaterial,
  Shape,
  sRGBEncoding,
  Texture,
  TextureLoader,
  Vector3,
} from 'three'
// import nxURL from '../assets/nx.png'
// import nyURL from '../assets/ny.png'
// import nzURL from '../assets/nz.png'
// import pxURL from '../assets/px.png'
// import pyURL from '../assets/py.png'
// import pzURL from '../assets/pz.png'

import nxURL from '../assets/negx.jpg'
import nyURL from '../assets/negy.jpg'
import nzURL from '../assets/negz.jpg'
import pxURL from '../assets/posx.jpg'
import pyURL from '../assets/posy.jpg'
import pzURL from '../assets/posz.jpg'
import { ConfigsType } from '../config.js'
import { CornerTwoDoorItemPropsType, HandleOrientationType } from './Item'
import { applyBoxUV } from './uvMapping.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
// @ts-ignore
import HandleObjURl from '../assets/handle.obj'
// @ts-ignore
import HandleDHP306ObjURl from '../assets/Handle_DHP306.obj'
// @ts-ignore
import HandleDHP465ObjURl from '../assets/Handle_DHP465.obj'
// @ts-ignore
import HandleDHP180ObjURl from '../assets/Handle_DHP180.obj'
// @ts-ignore
import HandleDHP504ObjURl from '../assets/Handle_DHP504.obj'
// @ts-ignore
import KnobDHK401ObjURl from '../assets/Knob_DHK401.obj'
// @ts-ignore
import KnobDHK301ObjURl from '../assets/Knob_DHK301.obj'

import {
  DoorNewVisualTypes,
  DoorVisualType,
  DrawerVisualType,
  HandlePropsType,
} from '../redux/cabinetReducer'
import { newDoorNormalMapsUrls } from './newDoorURLs'
import { cmToIn } from '../components/common/UnitComponents'
import { rgbToHex } from '../common/helpers'

const reflectionCubMap = new CubeTextureLoader().load([
  pxURL,
  nxURL,
  pyURL,
  nyURL,
  pzURL,
  nzURL,
])
reflectionCubMap.format = RGBFormat
reflectionCubMap.encoding = sRGBEncoding
reflectionCubMap.mapping = CubeReflectionMapping

const objLoader = new OBJLoader()

const handleGeos: Record<string, undefined | BufferGeometry> = {
  arch: undefined,
  DPH465: undefined,
  DPH306: undefined,
  DPH504: undefined,
  DPH180: undefined,
  Knob301: undefined,
  Knob401: undefined,
}

objLoader.load(HandleObjURl, (g) => {
  handleGeos.arch = (g.children[0] as Mesh).geometry as BufferGeometry
  handleGeos.arch.scale(0.1, 0.1, 0.1)
  handleGeos.arch.rotateX(Math.PI / 2)
  handleGeos.arch.rotateY(Math.PI / 2)
})

objLoader.load(HandleDHP465ObjURl, (g) => {
  handleGeos.DPH465 = (g.children[0] as Mesh).geometry as BufferGeometry
  handleGeos.DPH465.scale(0.1, 0.1, 0.1)
  handleGeos.DPH465.rotateX(Math.PI / 2)
  handleGeos.DPH465.rotateY(Math.PI / 2)
})

objLoader.load(HandleDHP306ObjURl, (g) => {
  handleGeos.DPH306 = (g.children[0] as Mesh).geometry as BufferGeometry
  handleGeos.DPH306.scale(0.1, 0.1, 0.1)
  handleGeos.DPH306.rotateX(Math.PI / 2)
  handleGeos.DPH306.rotateY(Math.PI / 2)
})

objLoader.load(HandleDHP180ObjURl, (g) => {
  handleGeos.DPH180 = (g.children[0] as Mesh).geometry as BufferGeometry
  handleGeos.DPH180.scale(0.1, 0.1, 0.1)
  handleGeos.DPH180.rotateX(Math.PI / 2)
  handleGeos.DPH180.rotateY(Math.PI / 2)
})

objLoader.load(HandleDHP504ObjURl, (g) => {
  handleGeos.DPH504 = (g.children[0] as Mesh).geometry as BufferGeometry
  handleGeos.DPH504.scale(0.1, 0.1, 0.1)
  handleGeos.DPH504.rotateX(Math.PI / 2)
  handleGeos.DPH504.rotateY(Math.PI / 2)
})

objLoader.load(KnobDHK301ObjURl, (g) => {
  handleGeos.Knob301 = (g.children[0] as Mesh).geometry as BufferGeometry
  handleGeos.Knob301.scale(0.1, 0.1, 0.1)
  handleGeos.Knob301.rotateX(Math.PI / 2)
  handleGeos.Knob301.rotateY(Math.PI / 2)
})

objLoader.load(KnobDHK401ObjURl, (g) => {
  handleGeos.Knob401 = (g.children[0] as Mesh).geometry as BufferGeometry
  handleGeos.Knob401.scale(0.1, 0.1, 0.1)
  handleGeos.Knob401.rotateX(Math.PI / 2)
  handleGeos.Knob401.rotateY(Math.PI / 2)
})

const safeDecodeAndParse = (input?: string) => {
  try {
    if (typeof input !== 'string') return {}
    const decoded = decodeURIComponent(input)
    return JSON.parse(decoded) as Object
  } catch (e) {
    return {}
  }
}

const loadTextures = (type: string) => {
  // @ts-ignore
  const maps = newDoorNormalMapsUrls[type]

  return new Promise((res, rej) => {
    const c1 = new Image()
    c1.src = maps[0]
    c1.onload = () => {
      const c2 = new Image()
      c2.src = maps[1]
      c2.onload = () => {
        const c3 = new Image()
        c3.src = maps[2]
        c3.onload = () => {
          const c4 = new Image()
          c4.src = maps[3]
          c4.onload = () => {
            const b1 = new Image()
            b1.src = maps[4]
            b1.onload = () => {
              const b2 = new Image()
              b2.src = maps[5]
              b2.onload = () => {
                const b3 = new Image()
                b3.src = maps[6]
                b3.onload = () => {
                  const b4 = new Image()
                  b4.src = maps[7]
                  b4.onload = () => {
                    if (type === 'B602R102') {
                      const center = new Image()
                      center.src = maps[8]
                      center.onload = () => {
                        res([c1, c2, c3, c4, b1, b2, b3, b4, center])
                      }
                    } else {
                      res([c1, c2, c3, c4, b1, b2, b3, b4])
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  })
}

function drawCorners(
  deltaHeight: number,
  canvasHeight: number,
  canvasWidth: number,
  ctx: CanvasRenderingContext2D,
  imgs: any,
  distX: number,
  distY: number,
  tWidth: any
) {
  const [c1, c2, c3, c4] = imgs

  // console.log(canvasHeight, canvasWidth)

  ctx.drawImage(c1, distX, distY + deltaHeight, tWidth, tWidth)
  ctx.drawImage(
    c2,
    canvasWidth - distX - tWidth,
    distY + deltaHeight,
    tWidth,
    tWidth
  )
  ctx.drawImage(
    c3,
    canvasWidth - distX - tWidth,
    canvasHeight - distY - tWidth + deltaHeight,
    tWidth,
    tWidth
  )

  ctx.drawImage(
    c4,
    distX,
    canvasHeight - distY - tWidth + deltaHeight,
    tWidth,
    tWidth
  )

  // rotateAndPaintImage(
  //   ctx,
  //   cornerImg,
  //   Math.PI / 2,
  //   canvas.width - distX - tWidth,
  //   distY,
  //   0,
  //   tWidth,
  //   tWidth,
  //   tWidth
  // );
  // ctx.drawImage(
  //   cornerImg,
  //   canvas.width - dist - tWidth,
  //   dist,
  //   tWidth,
  //   tWidth
  // );

  // rotateAndPaintImage(
  //   ctx,
  //   cornerImg,
  //   -Math.PI / 2,
  //   distX,
  //   canvas.height - distY - tWidth,
  //   tWidth,
  //   0,
  //   tWidth,
  //   tWidth
  // );
  // ctx.drawImage(
  //   cornerImg,
  //   dist,
  //   canvas.height - dist - tWidth,
  //   tWidth,
  //   tWidth
  // );

  // rotateAndPaintImage(
  //   ctx,
  //   cornerImg,
  //   Math.PI,
  //   canvas.width - distX - tWidth,
  //   canvas.height - distY - tWidth,
  //   tWidth,
  //   tWidth,
  //   tWidth,
  //   tWidth
  // );

  // ctx.drawImage(
  //   cornerImg,
  //   canvas.width - dist - tWidth,
  //   canvas.height - dist - tWidth,
  //   tWidth,
  //   tWidth
  // );
}

function drawBorders(
  deltaHeight: number,
  canvasHeight: number,
  canvasWidth: number,
  ctx: CanvasRenderingContext2D,
  patterns: any,
  distX: number,
  distY: number,
  tWidth: number
) {
  const [bp1, bp2, bp3, bp4] = patterns
  // ctx.fillStyle = bp1

  // Top
  ctx.drawImage(
    bp1,
    distX + tWidth,
    distY + deltaHeight,
    canvasWidth - distX * 2 - tWidth * 2,
    tWidth
  )

  // Right
  // ctx.fillStyle = bp2

  const rwidth = tWidth
  const rheight = canvasHeight - distY * 2 - tWidth * 2
  ctx.drawImage(
    bp2,
    canvasWidth - distX - tWidth,
    distY + tWidth + deltaHeight,
    rwidth,
    rheight
  )

  // ctx.fillStyle = bp3
  // Bottom
  const bwidth = canvasWidth - distX * 2 - tWidth * 2
  const bheight = tWidth
  ctx.drawImage(
    bp3,
    distX + tWidth,
    canvasHeight - distY - tWidth + deltaHeight,
    bwidth,
    bheight
  )

  // ctx.fillStyle = bp4
  // Left
  const lwidth = tWidth
  const lheight = canvasHeight - distY * 2 - tWidth * 2
  ctx.drawImage(bp4, distX, distY + tWidth + deltaHeight, lwidth, lheight)

  // Left
  // const lwidth = tWidth;
  // const lheight = canvas.height - distY * 2 - tWidth * 2;
  // rotateAndPaintPattern(
  //   ctx,
  //   pattern,
  //   Math.PI,
  //   distX,
  //   distY + tWidth,
  //   tWidth,
  //   lheight,
  //   lwidth,
  //   lheight
  // );
  // ctx.drawImage(
  //   borderImg,
  //   dist,
  //   dist + tWidth,
  //   tWidth,
  //   canvas.height - dist * 2 - tWidth * 2
  // );

  // Bottom
  // const bwidth = canvas.width - distX * 2 - tWidth * 2;
  // const bheight = tWidth;
  // rotateAndPaintPattern(
  //   ctx,
  //   pattern,
  //   Math.PI,
  //   distX + tWidth,
  //   canvas.height - distY - tWidth,
  //   bwidth,
  //   bheight,
  //   bwidth,
  //   bheight
  // );

  // ctx.drawImage(
  //   borderImg,
  //   dist + tWidth,
  //   canvas.height - dist - tWidth,
  //   canvas.width - dist * 2 - tWidth * 2,
  //   tWidth
  // );

  // // Right
  // const rwidth = tWidth;
  // const rheight = canvas.height - distY * 2 - tWidth * 2;
  // rotateAndPaintPattern(
  //   ctx,
  //   pattern,
  //   0,
  //   canvas.width - distX - tWidth,
  //   distY + tWidth,
  //   0,
  //   0,
  //   rwidth,
  //   rheight
  // );
  // ctx.drawImage(
  //   borderImg,
  //   canvas.width - dist - tWidth,
  //   dist + tWidth,
  //   tWidth,
  //   canvas.height - dist * 2 - tWidth * 2
  // );
}

function drawCenter(
  deltaHeight: number,
  canvasHeight: number,
  canvasWidth: number,
  ctx: CanvasRenderingContext2D,
  center: any,
  distX: number,
  distY: number,
  tWidth: number,
  patternDist: number,
  pixelMult: number
) {
  let count = Math.floor((canvasWidth - distX * 2) / patternDist)

  if (count % 2 === 0) {
    count--
  }

  const gapY = 0.2 * pixelMult

  const lwidth = tWidth
  const lheight = canvasHeight - distY * 2 - gapY

  const remainingSpace = canvasWidth - distX * 2 - count * patternDist

  let xPos = distX + remainingSpace / 2 //- lwidth / 2

  // console.log(canvasWidth, distX, patternDist, count, remainingSpace, xPos)

  for (let i = 0; i <= count; i++) {
    ctx.drawImage(
      center,
      xPos,
      // distX + patternDist * (i + 1),
      distY + deltaHeight + gapY / 2,
      lwidth,
      lheight
    )

    xPos += patternDist
  }
}

export const newDoorConfigs = {
  S01: {
    distXY: 0,
    tWidth: 0.325,
    maskDist: 0,
  },
  S04: {
    distXY: 0,
    tWidth: 0.125,
    maskDist: 0,
  },
  B200R203: {
    distXY: 2.25, // 5.715
    tWidth: 1.125,
    maskDist: 0.275, // 0.6985
    drawerDistY: 1.25,
    drawerMaxHeight: 7.5,
  },
  B200R401: {
    distXY: 2.25,
    tWidth: 1.125,
    maskDist: 0.5625,
    drawerDistY: 1.25,
    drawerMaxHeight: 7.5,
  },
  B200R500: {
    distXY: 2,
    tWidth: 1.312,
    maskDist: 0.125,
    drawerDistY: 1,
    drawerMaxHeight: 8,
  },
  B600R100: {
    distXY: 2,
    tWidth: 0.25,
    maskDist: 0.25,
    drawerDistY: 1,
    drawerMaxHeight: 7,
  },
  B600R102: {
    distXY: 2.25,
    tWidth: 0.1, //? not exists in photos
    maskDist: 0.1,
    drawerDistY: 1.25,
    drawerMaxHeight: 6,
  },
  B602R102: {
    distXY: 2.25,
    tWidth: 0.1, //
    maskDist: 0.1,
    drawerDistY: 1.25,
    drawerMaxHeight: 6,
  },
  B100R000: {
    distXY: 2.25, // 5.715
    tWidth: 0,
    maskDist: 0.275, // 0.6985
    drawerDistY: 1.25,
    drawerMaxHeight: 7.5,
  },
}

type NewDoorHoleType = 'none' | 'xglass' | 'clean' | 'mirror' | 'frosted'

export const getNewDoorHoleSizes = (
  isDouble: boolean,
  type: DoorNewVisualTypes,
  width: number,
  height: number,
  splitters: string
) => {
  const pixelMult = 10

  const doorInnerType = type.replaceAll('-', '').slice(1, 9)
  // @ts-ignore
  const distX = newDoorConfigs[doorInnerType].distXY * 2.54
  // @ts-ignore
  const maskDist = newDoorConfigs[doorInnerType].maskDist * 2.54
  const distY = distX

  // console.log(height, maskDist, distY, '5555555555555555555')

  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  // debugger

  let holeHeight = 0

  let glassHeight = 0
  let cleanHeight = 0
  let mirrorHeight = 0
  let frostedHeight = 0

  if (pieces.length === 1 && pieces[0].whole) {
    if (pieces[0].holeType !== 'none') {
      const holeHeight = height - 2 * distY - 2 * maskDist

      if (pieces[0].holeType === 'clean') {
        cleanHeight = holeHeight
      } else if (pieces[0].holeType === 'mirror') {
        mirrorHeight = holeHeight
      } else if (pieces[0].holeType === 'frosted') {
        frostedHeight = holeHeight
      } else if (pieces[0].holeType === 'xglass') {
        glassHeight = holeHeight
      }
    }
  } else {
    for (let i = 0; i < pieces.length; i++) {
      const piece = pieces[i]

      if (piece.holeType !== 'none') {
        let holeHeight = piece.num

        if (i === 0 || i === pieces.length - 1) {
          holeHeight -= 1.5 * distY + 2 * maskDist
        } else {
          holeHeight -= distY + 2 * maskDist
        }

        if (piece.holeType === 'clean') {
          cleanHeight += holeHeight
        } else if (piece.holeType === 'mirror') {
          mirrorHeight += holeHeight
        } else if (piece.holeType === 'frosted') {
          frostedHeight += holeHeight
        } else if (piece.holeType === 'xglass') {
          glassHeight += holeHeight
        }
      }
    }
  }

  return {
    width: isDouble
      ? (width - (distX + maskDist) * 4) / 2
      : width - (distX + maskDist) * 2,
    glassHeight,
    cleanHeight,
    mirrorHeight,
    frostedHeight,
  }
}

export const getFivePiecesDoorProps = (
  isDouble: boolean,
  width: number,
  height: number,
  splitters: string,
  pieceWidth: number,
  doorConfig: ConfigsType['doorConfig']
) => {
  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  // debugger

  // let holeHeight = 0

  let sheetHeight = 0
  let glassHeight = 0
  let cleanHeight = 0
  let mirrorHeight = 0
  let frostedHeight = 0

  if (pieces.length === 1 && pieces[0].whole) {
    const holeHeight = height - 2 * pieceWidth

    if (pieces[0].holeType === 'clean') {
      cleanHeight = holeHeight
    } else if (pieces[0].holeType === 'mirror') {
      mirrorHeight = holeHeight
    } else if (pieces[0].holeType === 'frosted') {
      frostedHeight = holeHeight
    } else if (pieces[0].holeType === 'xglass') {
      glassHeight = holeHeight
    } else {
      sheetHeight += holeHeight
    }
  } else {
    for (let i = 0; i < pieces.length; i++) {
      const piece = pieces[i]

      let holeHeight = piece.num

      if (i === 0 || i === pieces.length - 1) {
        holeHeight -= 1.5 * pieceWidth
      } else {
        holeHeight -= pieceWidth
      }

      if (piece.holeType === 'clean') {
        cleanHeight += holeHeight
      } else if (piece.holeType === 'mirror') {
        mirrorHeight += holeHeight
      } else if (piece.holeType === 'frosted') {
        frostedHeight += holeHeight
      } else if (piece.holeType === 'xglass') {
        glassHeight += holeHeight
      } else {
        sheetHeight += holeHeight
      }
    }
  }

  let holeWidth = width - pieceWidth * 2

  if (isDouble) {
    holeWidth -= doorConfig.verticalGap + pieceWidth * 2
    holeWidth /= 2
    // piecesLength = 4 * height + (pieces.length + 1) * holeWidth * 2
  }
  let piecesLength = 2 * height + (pieces.length + 1) * holeWidth

  return {
    holeWidth,
    glassHeight,
    mirrorHeight,
    cleanHeight,
    frostedHeight,
    sheetHeight,
    piecesLength,
  }
}

export const getFivePiecesCornerTwoDoorProps = (
  width1: number,
  width2: number,
  height: number,
  splitters: string,
  pieceWidth: number,
  doorConfig: ConfigsType['doorConfig']
) => {
  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  // debugger

  // let holeHeight = 0
  // console.log(width1, width2)

  let sheetHeight = 0
  let glassHeight = 0
  let cleanHeight = 0
  let mirrorHeight = 0
  let frostedHeight = 0

  if (pieces.length === 1 && pieces[0].whole) {
    const holeHeight = height - 2 * pieceWidth

    if (pieces[0].holeType === 'clean') {
      cleanHeight = holeHeight
    } else if (pieces[0].holeType === 'mirror') {
      mirrorHeight = holeHeight
    } else if (pieces[0].holeType === 'frosted') {
      frostedHeight = holeHeight
    } else if (pieces[0].holeType === 'xglass') {
      glassHeight = holeHeight
    } else {
      sheetHeight += holeHeight
    }
  } else {
    for (let i = 0; i < pieces.length; i++) {
      const piece = pieces[i]

      let holeHeight = piece.num

      if (i === 0 || i === pieces.length - 1) {
        holeHeight -= 1.5 * pieceWidth
      } else {
        holeHeight -= pieceWidth
      }

      if (piece.holeType === 'clean') {
        cleanHeight += holeHeight
      } else if (piece.holeType === 'mirror') {
        mirrorHeight += holeHeight
      } else if (piece.holeType === 'frosted') {
        frostedHeight += holeHeight
      } else if (piece.holeType === 'xglass') {
        glassHeight += holeHeight
      } else {
        sheetHeight += holeHeight
      }
    }
  }

  let holeWidth = width1 - pieceWidth * 2 + (width2 - pieceWidth * 2)

  let piecesLength = 4 * height + (pieces.length + 1) * holeWidth * 2

  return {
    holeWidth,
    glassHeight,
    mirrorHeight,
    cleanHeight,
    frostedHeight,
    sheetHeight,
    piecesLength,
  }
}

export const getFivePiecesDrawerProps = (
  width: number,
  height: number,
  verticalPieceWidth: number,
  horizontalPieceWidth: number
) => {
  const centerHeight = height - horizontalPieceWidth * 2
  const centerWidth = width - verticalPieceWidth * 2

  const verticalPiecesArea = 2 * height * verticalPieceWidth
  const horizontalPiecesArea =
    2 * (width - 2 * verticalPieceWidth) * horizontalPieceWidth

  return {
    centerHeight,
    centerWidth,
    piecesArea: verticalPiecesArea + horizontalPiecesArea,
  }
}

export const getNewDoorPiecesFromSplitters = (
  _splitters: string,
  doorHeight: number,
  unit: 'cm' | 'in'
) => {
  const holeTypeLetters = ['X', 'C', 'M', 'F']

  if (_splitters.length === 0) {
    return [
      {
        holeType: 'none',
        num: 0,
        whole: true,
      },
    ]
  }

  if (_splitters.length === 1) {
    if (_splitters === 'X') {
      return [
        {
          holeType: 'xglass',
          num: 0,
          whole: true,
        },
      ]
    }
    if (_splitters === 'C') {
      return [
        {
          holeType: 'clean',
          num: 0,
          whole: true,
        },
      ]
    }
    if (_splitters === 'M') {
      return [
        {
          holeType: 'mirror',
          num: 0,
          whole: true,
        },
      ]
    }
    if (_splitters === 'F') {
      return [
        {
          holeType: 'frosted',
          num: 0,
          whole: true,
        },
      ]
    }
  }
  // console.log(_splitters, doorHeight)
  let splitters = _splitters
    ? _splitters.split(',').map((n) => {
        if (n === '') {
          return ''
        } else {
          let holeType: NewDoorHoleType = 'none'

          if (n) {
            if (holeTypeLetters.includes(n[0])) {
              if (n[0] === 'X') {
                holeType = 'xglass'
              } else if (n[0] === 'C') {
                holeType = 'clean'
              } else if (n[0] === 'M') {
                holeType = 'mirror'
              } else if (n[0] === 'F') {
                holeType = 'frosted'
              }

              n = n.slice(1)
            }
          }

          const num = parseFloat(parseFloat(n).toFixed(1))
          return isNaN(num) ? -1 : { holeType, num, whole: false }
        }
      })
    : []

  if (splitters.some((s) => s === -1)) {
    // wrong values
    return []
  }

  if (splitters.some((s) => s === '')) {
    const emptyCount = splitters.filter((s) => s === '').length
    const height =
      (doorHeight -
        splitters
          .filter((s) => s !== '' && s !== -1)
          .reduce((acc, v) => acc + v.num, 0)) /
      emptyCount

    splitters = splitters.map((s) =>
      s === ''
        ? { holeType: 'none', num: parseFloat(height.toFixed(1)), whole: false }
        : s
    )
  }

  if (unit === 'in') {
    // console.log(splitters)
    // @ts-ignore
    splitters = splitters
      .filter((s) => s !== '' && s !== -1)
      .map((s) => ({ ...s, num: cmToIn(s.num as number) }))
    // console.log(splitters)
  }

  return splitters.filter((s) => s !== '' && s !== -1)
}

const getNewDoorNormalMap = async (
  type: DoorNewVisualTypes,
  canW = 200,
  canH = 250,
  _splitters: string,
  forDrawer = false
) => {
  const canvas = document.createElement('canvas')

  // canvas.style.width = canW + "px"
  // canvas.style.height = canH + "px"
  // console.log(canW, canH, _splitters)
  const pixelMult = 10
  canvas.width = canW * pixelMult
  canvas.height = canH * pixelMult

  const ctx = canvas.getContext('2d')
  if (!ctx) return new CanvasTexture(canvas)

  const doorInnerType = type.replaceAll('-', '').slice(1, 9)
  const doorOuterType = type.replaceAll('-', '').slice(9, 12)

  // @ts-ignore
  const outerTWidth = newDoorConfigs[doorOuterType].tWidth * 2.54 * pixelMult

  // @ts-ignore
  const distX = newDoorConfigs[doorInnerType].distXY * 2.54 * pixelMult
  let distY = distX

  if (forDrawer) {
    // @ts-ignore
    const configs = newDoorConfigs[doorInnerType]
    const drawerMaxHeight = configs.drawerMaxHeight * 2.54

    if (canH < drawerMaxHeight) {
      distY = configs.drawerDistY * 2.54 * pixelMult
    }

    // newDoorConfigs.drawerDistY * 2.54 * pixelMult
  }

  // @ts-ignore
  const tWidth = newDoorConfigs[doorInnerType].tWidth * 2.54 * pixelMult

  // @ts-ignore // inner
  const [c1, c2, c3, c4, b1, b2, b3, b4, center] =
    doorInnerType === 'B100R000' ? [] : await loadTextures(doorInnerType)

  // @ts-ignore //outer
  const [oc1, oc2, oc3, oc4, ob1, ob2, ob3, ob4] = await loadTextures(
    doorOuterType
  )

  // ctx.imageSmoothingEnabled = false
  ctx.fillStyle = '#bbbbff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  // alert(splitters === 0 ? canvas.height : canvas.height / (splitters + 1))

  let splitters = getNewDoorPiecesFromSplitters(
    _splitters,
    canvas.height / pixelMult,
    'cm'
  )

  splitters = splitters.length === 1 && splitters[0].whole ? [] : splitters

  console.log('============', splitters)

  // let splitters = _splitters
  //   ? _splitters.split(',').map((n) => {
  //       if (n === '') {
  //         return ''
  //       } else {
  //         const num = parseFloat(n) * pixelMult
  //         return isNaN(num) ? -1 : num
  //       }
  //     })
  //   : []

  // if (splitters.some((s) => s === -1)) {
  //   // wrong values
  //   splitters = []
  // }

  // if (splitters.some((s) => s === '')) {
  //   const emptyCount = splitters.filter((s) => s === '').length
  //   const height =
  //     (canvas.height -
  //       splitters.filter((s) => s !== '').reduce((acc, v) => acc + v, 0)) /
  //     emptyCount

  //   splitters = splitters.map((s) => (s === '' ? height : s))
  // }

  // console.log(splitters)
  // splitters = splitters.some((s) => isNaN(s)) ? [] : splitters

  // console.log(splitters)

  if (doorInnerType !== 'B100R000') {
    if (splitters.length === 0) {
      // Inner
      drawCorners(
        0,
        canvas.height,
        canvas.width,
        ctx,
        [c1, c2, c3, c4],
        distX,
        distY,
        tWidth
      )
      drawBorders(
        0,
        canvas.height,
        canvas.width,
        ctx,
        [b1, b2, b3, b4],
        distX,
        distY,
        tWidth
      )

      if (doorInnerType === 'B602R102') {
        drawCenter(
          0,
          canvas.height,
          canvas.width,
          ctx,
          center,
          distX,
          distY,
          // 0.3 * pixelMult,
          1 * pixelMult,
          3.81 * pixelMult,
          pixelMult
        )
      }
    } else {
      const pieces = splitters
        .map((s) => s.num * pixelMult)
        .reverse() as number[]
      console.log('----------', pieces)

      let prevPiecesHeight = 0 //splitters.reduce((acc,v) => acc + v)
      let deltaHeight = distY //splitters.reduce((acc,v) => acc + v)

      for (let i = 0; i < pieces.length; i++) {
        const pieceHeight = pieces[i]

        // const deltaHeight = i * pieceHeight - i * distY
        const actualPieceHeight =
          i === 0 || i === pieces.length - 1
            ? pieceHeight - distY * 1.5
            : pieceHeight - distY
        // Inner
        drawCorners(
          deltaHeight,
          actualPieceHeight,
          canvas.width,
          ctx,
          [c1, c2, c3, c4],
          distX,
          // deltaHeight === 0 ? distY : 0,
          0,
          tWidth
        )

        // console.log(
        //   i,
        //   deltaHeight,
        //   pieceHeight,
        //   actualPieceHeight
        //   // deltaHeight === 0 ? pieceHeight : pieceHeight - distY,
        //   // deltaHeight === 0 ? distY : 0
        // )
        drawBorders(
          deltaHeight,
          actualPieceHeight,
          canvas.width,
          ctx,
          [b1, b2, b3, b4],
          distX,
          0,
          tWidth
        )

        if (doorInnerType === 'B602R102') {
          drawCenter(
            deltaHeight - distY,
            actualPieceHeight + distY * 2,
            canvas.width,
            ctx,
            center,
            distX,
            distY,
            // 0.3 * pixelMult,
            1 * pixelMult,
            3.81 * pixelMult,
            pixelMult
          )
        }

        prevPiecesHeight += pieceHeight
        deltaHeight += actualPieceHeight + distY
      }
    }
  }

  // Outer
  drawCorners(
    0,
    canvas.height,
    canvas.width,
    ctx,
    [oc1, oc2, oc3, oc4],
    0,
    0,
    outerTWidth
  )
  drawBorders(
    0,
    canvas.height,
    canvas.width,
    ctx,
    [ob1, ob2, ob3, ob4],
    0,
    0,
    outerTWidth
  )

  // if (doorInnerType === 'B100R000') {
  //   const link = document.createElement('a')
  //   link.download = 'filename'
  //   link.href = canvas.toDataURL('image/png')
  //   link.click()
  // }
  return new CanvasTexture(canvas)
}

const getNewDoorMaskMap = async (
  type: DoorNewVisualTypes,
  canW = 200,
  canH = 250,
  _splitters: string,
  forDrawer = false
) => {
  const canvas = document.createElement('canvas')

  const pixelMult = 10
  canvas.width = canW * pixelMult
  canvas.height = canH * pixelMult

  const ctx = canvas.getContext('2d')
  if (!ctx) return new CanvasTexture(canvas)

  const doorInnerType = type.replaceAll('-', '').slice(1, 9)
  // @ts-ignore
  const distX = newDoorConfigs[doorInnerType].distXY * 2.54 * pixelMult
  const distY = distX
  //  @ts-ignore
  const tWidth = newDoorConfigs[doorInnerType].tWidth * 2.54 * pixelMult
  //  @ts-ignore
  const maskWidth = newDoorConfigs[doorInnerType].maskDist * 2.54 * pixelMult

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  let splitters = getNewDoorPiecesFromSplitters(
    _splitters,
    canvas.height / pixelMult,
    'cm'
  )

  // splitters = splitters.length === 1 && splitters[0].whole ? [] :splitters
  // let splitters = _splitters
  //   ? _splitters.split(',').map((n) => {
  //       if (n === '') {
  //         return ''
  //       } else {
  //         const num = parseFloat(n) * pixelMult
  //         return isNaN(num) ? -1 : num
  //       }
  //     })
  //   : []

  // if (splitters.some((s) => s === -1)) {
  //   // wrong values
  //   splitters = []
  // }

  // if (splitters.some((s) => s === '')) {
  //   const emptyCount = splitters.filter((s) => s === '').length
  //   const height =
  //     (canvas.height -
  //       splitters.filter((s) => s !== '').reduce((acc, v) => acc + v, 0)) /
  //     emptyCount

  //   splitters = splitters.map((s) => (s === '' ? height : s))
  // }
  // console.log(splitters)
  // splitters = splitters.some((s) => isNaN(s)) ? [] : splitters

  console.log('splitters', splitters)

  const maskGap = 0 * 2.54 * pixelMult

  if (
    splitters.length === 0 ||
    (splitters.length === 1 &&
      splitters[0].whole &&
      splitters[0].holeType !== 'none')
  ) {
    const maskDistX = distX + maskWidth + maskGap
    const maskDistY = distY + maskWidth + maskGap

    ctx.fillStyle = '#000000'
    ctx.fillRect(
      maskDistX,
      maskDistY,
      canvas.width - maskDistX * 2,
      canvas.height - maskDistY * 2
    )
    console.log(
      canvas.height,
      distY,
      maskWidth,
      canvas.height - maskDistY * 2,
      '$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$'
    )
  } else {
    const pieces = splitters
      .map((s) => ({ ...s, num: s.num * pixelMult }))
      .reverse()

    let prevPiecesHeight = 0 //splitters.reduce((acc,v) => acc + v)
    let deltaHeight = distY + maskWidth + maskGap //splitters.reduce((acc,v) => acc + v)

    const maskXDist = distX + maskWidth + maskGap

    ctx.fillStyle = '#000000'

    for (let i = 0; i < pieces.length; i++) {
      const pieceHeight = pieces[i].num

      // const deltaHeight = i * pieceHeight - i * distY
      const actualPieceHeight =
        i === 0 || i === pieces.length - 1
          ? pieceHeight - maskGap * 2 - maskWidth * 2 - distY * 1.5
          : pieceHeight - maskGap * 2 - maskWidth * 2 - distY
      // Inner
      // drawCorners(
      //   deltaHeight,
      //   actualPieceHeight,
      //   canvas.width,
      //   ctx,
      //   [c1, c2, c3, c4],
      //   distX,
      //   // deltaHeight === 0 ? distY : 0,
      //   0,
      //   tWidth
      // )

      if (pieces[i].holeType !== 'none')
        ctx.fillRect(
          maskXDist,
          deltaHeight,
          canvas.width - maskXDist * 2,
          actualPieceHeight
        )
      // if (i === 0)
      //   ctx.fillRect(
      //     maskXDist,
      //     0, //deltaHeight + tWidth + maskGap,
      //     canvas.width - maskXDist * 2,
      //     pieceHeight //actualPieceHeight
      //   )

      console.log(
        i,
        deltaHeight,
        tWidth,
        pieceHeight,
        actualPieceHeight,
        deltaHeight + tWidth + maskGap
        // deltaHeight === 0 ? pieceHeight : pieceHeight - distY,
        // deltaHeight === 0 ? distY : 0
      )

      prevPiecesHeight += pieceHeight
      deltaHeight += actualPieceHeight + distY + maskGap * 2 + maskWidth * 2
    }
  }

  if (false) {
    const link = document.createElement('a')
    link.download = 'filename'
    link.href = canvas.toDataURL('image/png')
    link.click()
  }
  return new CanvasTexture(canvas)
}

const getNewDoorHoleMaterialProps = (
  splitters: string,
  forFivePiece = false
) => {
  if (splitters.includes('G')) {
    return {
      color: 0x999999,
      metalness: 1,
      roughness: 0.0,
      opacity: 0.3,
    }
  }
  if (splitters.includes('M')) {
    return {
      color: forFivePiece ? 0xffffff : 0x000000,
      metalness: 1,
      roughness: 0,
      opacity: 1,
    }
  }
  if (splitters.includes('F')) {
    return {
      color: 0xffffff,
      metalness: 0.5,
      roughness: 0.5,
      opacity: 0.5,
    }
  }

  return {
    color: 0xffffff,
    metalness: 1,
    roughness: 0.0,
    opacity: 0.5,
  }
}

export const createSheet = (
  length: number,
  width: number,
  thickness: number,
  material: Material | Material[] = new MeshNormalMaterial()
) => {
  return new Mesh(new BoxGeometry(length, width, thickness), material)
}

export const createSideSheetForBaseLegs = (
  cabinetHeight: number,
  legHeight: number,
  width: number,
  thickness: number,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  baseLegConfig: ConfigsType['baseLegConfig'],
  _cutLength?: number,
  _backCut?: number
) => {
  const extrudeSettings = {
    steps: 1,
    depth: thickness,
    bevelEnabled: false,
    bevelThickness: 0.05,
    bevelSize: 0.05,
    bevelOffset: -0.1,
    bevelSegments: 1,
  }

  const cutLength = _cutLength || baseLegConfig.cutLength
  const backCut = _backCut || 0

  const shape = new Shape()

  // shape.moveTo(0, 0)
  // shape.lineTo(0, cabinetHeight + legHeight)
  // shape.lineTo(width - cutLength, cabinetHeight + legHeight)
  // shape.lineTo(width - cutLength, cabinetHeight)
  // shape.lineTo(width, cabinetHeight)
  // shape.lineTo(width, 0)
  // shape.lineTo(0, 0)

  shape.moveTo(0, 0)
  shape.lineTo(0, cabinetHeight)
  shape.lineTo(backCut, cabinetHeight)
  shape.lineTo(backCut, cabinetHeight + legHeight)
  shape.lineTo(width - cutLength, cabinetHeight + legHeight)
  shape.lineTo(width - cutLength, cabinetHeight)
  shape.lineTo(width, cabinetHeight)
  shape.lineTo(width, 0)
  shape.lineTo(0, 0)

  const geometry = new ExtrudeGeometry(shape, extrudeSettings)

  const newTexture = texture.clone()
  newTexture.wrapS = RepeatWrapping
  newTexture.wrapT = RepeatWrapping
  newTexture.repeat.set(1, tLength / tWidth)
  newTexture.needsUpdate = true

  applyBoxUV(
    geometry,
    new Matrix4().fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
    tLength
  )

  geometry.attributes.uv.needsUpdate = true

  return new Mesh(geometry, new MeshStandardMaterial({ map: newTexture }))
}

export const createSection = (
  width: number,
  height: number,
  material: Material = new MeshBasicMaterial({
    color: 'white',
    transparent: true,
    opacity: 0.6,
  })
) => new Mesh(new PlaneGeometry(width, height), material)

export const createDivider = (
  width: number,
  height: number = 1,
  material: Material = new MeshBasicMaterial({ color: 'black' })
) => new Mesh(new PlaneGeometry(width, height), material)

export const createCylinderHandle = (
  hPosition: 'left' | 'right' | 'center',
  orientation: HandleOrientationType,
  handleConfig: ConfigsType['handleConfig'],
  color?: Color,
  noPull = false,
  threeProps?: string
) => {
  // if (orientation === 'horizontal')
  //   return createHorizontalCylinderHandle(handleConfig, color)
  const threePropsObj = safeDecodeAndParse(threeProps)

  const length = handleConfig.length
  const diameter = handleConfig.diameter
  const dist = handleConfig.legDist
  const legLength = handleConfig.legLength
  const legDiameter = handleConfig.legDiameter

  const material = !noPull
    ? new MeshPhysicalMaterial({
        metalness: 1,
        roughness: 0,
        envMap: reflectionCubMap,
        color,
        ...threePropsObj,
      })
    : new MeshBasicMaterial({
        color,
        transparent: true,
        opacity: 0.2,
      })

  const g = new Group()

  const base = new Mesh(
    new CylinderGeometry(diameter / 2, diameter / 2, length, 24),
    material
  )

  const leg1 = new Mesh(
    new CylinderGeometry(
      legDiameter / 2 - 0.05,
      legDiameter / 2 - 0.1,
      legLength,
      24
    ),
    material
  )

  const leg2 = new Mesh(
    new CylinderGeometry(
      legDiameter / 2 - 0.05,
      legDiameter / 2 - 0.1,
      legLength,
      24
    ),
    material
  )

  g.add(base)
  g.add(leg1)
  g.add(leg2)

  leg1.rotation.x = Math.PI / 2
  leg2.rotation.x = Math.PI / 2
  leg1.position.set(0, -dist / 2, 0)
  leg2.position.set(0, dist / 2, 0)
  base.position.set(0, 0, legLength / 2)

  if (orientation === 'horizontal' && hPosition !== 'center') {
    const g2 = new Group()
    g2.add(g)
    g.position.set(0, dist / 2, 0)
    g2.rotation.z = (Math.PI / 2) * (hPosition === 'left' ? -1 : 1)

    return g2
  }

  return g
}

export const createArchHandle = (
  hPosition: 'left' | 'right' | 'center',
  orientation: HandleOrientationType,
  color?: Color,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const material = new MeshPhysicalMaterial({
    metalness: 1,
    roughness: 0,
    envMap: reflectionCubMap,
    color,
    ...threePropsObj,
  })

  const handle = new Mesh(handleGeos.arch || new BufferGeometry(), material)

  if (orientation === 'horizontal' && hPosition !== 'center') {
    const bbox = new Box3().setFromObject(handle)
    const height = bbox.max.y - bbox.min.y

    const g = new Group()
    g.add(handle)
    handle.position.set(0, height / 2, 0)
    g.rotation.z = (Math.PI / 2) * (hPosition === 'left' ? -1 : 1)

    return g
  }

  // handle.add(new BoxHelper(handle, 0xff0000))
  return handle
}

export const createNewHandle = (
  subType: HandlePropsType['subtype'],
  hPosition: 'left' | 'right' | 'center',
  orientation: HandleOrientationType,
  color?: Color,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const material = new MeshPhysicalMaterial({
    metalness: 1,
    roughness: 0,
    envMap: reflectionCubMap,
    color,
    ...threePropsObj,
  })

  let geo = undefined as undefined | BufferGeometry

  if (subType === 'DHP306-96') {
    geo = handleGeos.DPH306
  } else if (subType === 'DHP465-192') {
    geo = handleGeos.DPH465
  } else if (subType === 'DHP180-128') {
    geo = handleGeos.DPH180
  } else if (subType === 'DHP504-76') {
    geo = handleGeos.DPH504
  } else if (subType === 'DHK301') {
    geo = handleGeos.Knob301
  } else if (subType === 'DHK401') {
    geo = handleGeos.Knob401
  }

  const handle = new Mesh(geo || new BufferGeometry(), material)

  if (orientation === 'horizontal' && hPosition !== 'center') {
    const bbox = new Box3().setFromObject(handle)
    const height = bbox.max.y - bbox.min.y

    const g = new Group()
    g.add(handle)
    handle.position.set(0, height / 2, 0)
    g.rotation.z = (Math.PI / 2) * (hPosition === 'left' ? -1 : 1)

    return g
  }

  if (subType === 'DHP504-76') {
    handle.rotation.x = -Math.PI / 2
    handle.rotation.z = -Math.PI / 2
  }

  // handle.add(new BoxHelper(handle, 0xff0000))
  return handle
}

export const createDoorVGroove = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  width: number,
  height: number,
  thickness: number,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  vGrooveConfig: ConfigsType['vGrooveConfig'],
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const extrudeSettings = {
    steps: 1,
    depth: height - 0.1,
    bevelEnabled: false,
    bevelThickness: 0.05,
    bevelSize: 0.05,
    bevelOffset: -0.1,
    bevelSegments: 1,
  }

  const g = new Group()

  if (type === 'right') {
    const shape = new Shape()

    shape.moveTo(0, 0)
    shape.lineTo(0, thickness)

    shape.lineTo(vGrooveConfig.distance, thickness)
    shape.lineTo(
      vGrooveConfig.distance + vGrooveConfig.length / 2,
      thickness - vGrooveConfig.prof
    )
    shape.lineTo(vGrooveConfig.distance + vGrooveConfig.length, thickness)
    shape.lineTo(width, thickness)
    shape.lineTo(width, 0)
    shape.lineTo(0, 0)

    const geometry = new ExtrudeGeometry(shape, extrudeSettings)

    const newTexture = texture.clone()
    newTexture.wrapS = RepeatWrapping
    newTexture.wrapT = RepeatWrapping
    newTexture.repeat.set(1, tLength / tWidth)
    newTexture.needsUpdate = true

    applyBoxUV(
      geometry,
      new Matrix4().fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      tLength
    )

    geometry.attributes.uv.needsUpdate = true

    const mesh = new Mesh(
      geometry,
      new MeshStandardMaterial({ map: newTexture, ...threePropsObj })
    )

    mesh.rotateX(Math.PI / 2)
    mesh.position.x -= width / 2
    mesh.position.y += height / 2
    mesh.position.z -= thickness / 2

    g.add(mesh)
  } else if (type === 'left') {
    const shape = new Shape()

    shape.moveTo(0, 0)
    shape.lineTo(0, thickness)

    shape.lineTo(
      width - vGrooveConfig.length - vGrooveConfig.distance,
      thickness
    )
    shape.lineTo(
      width - vGrooveConfig.length / 2 - vGrooveConfig.distance,
      thickness - vGrooveConfig.prof
    )
    shape.lineTo(width - vGrooveConfig.distance, thickness)
    shape.lineTo(width, thickness)
    shape.lineTo(width, 0)
    shape.lineTo(0, 0)

    const geometry = new ExtrudeGeometry(shape, extrudeSettings)

    const newTexture = texture.clone()
    newTexture.wrapS = RepeatWrapping
    newTexture.wrapT = RepeatWrapping
    newTexture.repeat.set(1, tLength / tWidth)
    newTexture.needsUpdate = true

    applyBoxUV(
      geometry,
      new Matrix4().fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      tLength
    )

    geometry.attributes.uv.needsUpdate = true

    const mesh = new Mesh(
      geometry,
      new MeshStandardMaterial({ map: newTexture, ...threePropsObj })
    )

    mesh.rotateX(Math.PI / 2)
    mesh.position.x -= width / 2
    mesh.position.y += height / 2
    mesh.position.z -= thickness / 2

    g.add(mesh)
  } else if (type === 'double') {
    const newTexture = texture.clone()
    newTexture.wrapS = RepeatWrapping
    newTexture.wrapT = RepeatWrapping
    newTexture.repeat.set(1, tLength / tWidth)
    newTexture.needsUpdate = true

    const leftSheetWidth = width / 2 - doorConfig.verticalGap / 2
    const rightSheetWidth = width / 2 - doorConfig.verticalGap / 2

    const lShape = new Shape()

    lShape.moveTo(0, 0)
    lShape.lineTo(0, thickness)

    lShape.lineTo(
      leftSheetWidth - vGrooveConfig.length - vGrooveConfig.distance,
      thickness
    )
    lShape.lineTo(
      leftSheetWidth - vGrooveConfig.length / 2 - vGrooveConfig.distance,
      thickness - vGrooveConfig.prof
    )
    lShape.lineTo(leftSheetWidth - vGrooveConfig.distance, thickness)
    lShape.lineTo(leftSheetWidth, thickness)
    lShape.lineTo(leftSheetWidth, 0)
    lShape.lineTo(0, 0)

    const lGeometry = new ExtrudeGeometry(lShape, extrudeSettings)

    applyBoxUV(
      lGeometry,
      new Matrix4().fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      tLength
    )

    lGeometry.attributes.uv.needsUpdate = true

    const leftSheet = new Mesh(
      lGeometry,
      new MeshStandardMaterial({ map: newTexture, ...threePropsObj })
    )

    const rShape = new Shape()

    rShape.moveTo(0, 0)
    rShape.lineTo(0, thickness)

    rShape.lineTo(vGrooveConfig.distance, thickness)
    rShape.lineTo(
      vGrooveConfig.distance + vGrooveConfig.length / 2,
      thickness - vGrooveConfig.prof
    )
    rShape.lineTo(vGrooveConfig.distance + vGrooveConfig.length, thickness)
    rShape.lineTo(rightSheetWidth, thickness)
    rShape.lineTo(rightSheetWidth, 0)
    rShape.lineTo(0, 0)

    const rGeometry = new ExtrudeGeometry(rShape, extrudeSettings)
    const rightSheet = new Mesh(
      rGeometry,
      new MeshStandardMaterial({ map: newTexture, ...threePropsObj })
    )

    applyBoxUV(
      rGeometry,
      new Matrix4().fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      tLength
    )

    rGeometry.attributes.uv.needsUpdate = true

    g.add(leftSheet)
    g.add(rightSheet)

    leftSheet.rotateX(Math.PI / 2)
    rightSheet.rotateX(Math.PI / 2)

    leftSheet.position.x = -leftSheetWidth / 2 - doorConfig.verticalGap / 2
    rightSheet.position.x = rightSheetWidth / 2 + doorConfig.verticalGap / 2

    leftSheet.position.x -= leftSheetWidth / 2
    rightSheet.position.x -= rightSheetWidth / 2
    leftSheet.position.y += height / 2
    rightSheet.position.y += height / 2
    leftSheet.position.z -= thickness / 2
    rightSheet.position.z -= thickness / 2
  } else if (type === 'liftUp') {
    const sheet = createSheet(
      width,
      height,
      thickness,
      new MeshStandardMaterial({ map: texture, ...threePropsObj })
    )

    g.add(sheet)
  }
  return g
}

export const _createLiftUpDoor = (
  width: number,
  height: number,
  thickness: number,
  material: Material = new MeshNormalMaterial()
) => {
  const g = new Group()

  const sheet = createSheet(width, height, thickness, material)

  g.add(sheet)

  return g
}

const getTextureColor = (texture: Texture) => {
  const canvas = document.createElement('canvas')
  const pic = texture.image

  canvas.width = pic.width
  canvas.height = pic.height
  const ctx = canvas.getContext('2d')

  if (ctx) {
    ctx.drawImage(pic, 0, 0)
    var p = ctx.getImageData(7, 7, 1, 1).data
    // console.log('=============GGGGGGGGGGGGGGGGGGG=============', p)
    return rgbToHex(p[0], p[1], p[2])
  }

  return '#FFFFFF'
}

export const createNewDoors = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  subtype: DoorNewVisualTypes,
  splitters: string,
  width: number,
  height: number,
  thickness: number,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  forDrawer = false,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  console.log(splitters)
  const sheetWidth =
    type !== 'double' ? width : width / 2 - doorConfig.verticalGap / 2

  const newTexture = texture.clone()

  newTexture.repeat.set(width / tLength, height / tWidth)
  newTexture.needsUpdate = true
  const material = new MeshStandardMaterial({ map: texture })
  let textureColor = getTextureColor(texture)

  // const materials = [
  //   new MeshStandardMaterial(),
  //   new MeshStandardMaterial(),
  //   new MeshStandardMaterial(),
  //   new MeshStandardMaterial(),
  //   new MeshStandardMaterial(),
  //   new MeshStandardMaterial(),
  // ]
  const materials = [material, material, material, material, material, material]

  const g = new Group()

  if (type === 'double') {
    const lSheet = createSheet(sheetWidth, height, thickness, materials)
    const rSheet = createSheet(sheetWidth, height, thickness, materials)

    lSheet.position.x = -sheetWidth / 2 - doorConfig.verticalGap / 2
    rSheet.position.x = sheetWidth / 2 + doorConfig.verticalGap / 2

    g.add(lSheet)
    g.add(rSheet)
  } else {
    const sheet = createSheet(width, height, thickness, materials)

    g.add(sheet)
  }

  const mat = new ShaderMaterial()
  getNewDoorNormalMap(subtype, sheetWidth, height, splitters, forDrawer).then(
    (map) => {
      getNewDoorMaskMap(subtype, sheetWidth, height, splitters, forDrawer).then(
        (mask) => {
          // Material 1: Red, metallic
          const material2 = new MeshStandardMaterial({
            // color: 0xbbbbbb,
            color: textureColor,
            metalness: 0,
            roughness: 0.2,
            envMap: reflectionCubMap,
            normalMap: map,
            transparent: true,
            opacity: 1, // Fully opaque
            ...threePropsObj,
          })

          const matProps = getNewDoorHoleMaterialProps(splitters)

          // Material 2: Blue, non-metallic with transparency
          const material1 = new MeshStandardMaterial({
            color: matProps.color,
            metalness: matProps.metalness,
            roughness: matProps.roughness,
            envMap: reflectionCubMap,
            transparent: true,
            opacity: matProps.opacity, // Fully transparent
          })

          // mat.normalMap = map
          // mat.normalScale.set(3, 3)
          // mat.needsUpdate = true

          //   mat.needsUpdate = true
          const lightColor = new Color(1, 1, 1)
          const lightDirection = new Vector3(5, 10, 7.5).normalize()
          const ambientLight = new Color(0.4, 0.4, 0.4)

          const blendingMaterial = new ShaderMaterial({
            uniforms: {
              material1Color: { value: material1.color },
              material1Metalness: { value: material1.metalness },
              material1Roughness: { value: material1.roughness },
              material1Opacity: { value: material1.opacity },
              material1NormalMap: { value: map },
              hasMaterial1NormalMap: { value: true },

              material2Color: { value: material2.color },
              material2Metalness: { value: material2.metalness },
              material2Roughness: { value: material2.roughness },
              material2Opacity: { value: material2.opacity },
              material2NormalMap: { value: null }, // Placeholder for optional second normal map
              hasMaterial2NormalMap: { value: false },

              maskTexture: { value: mask },
              envMap: { value: material2.envMap },

              // Lighting uniforms
              lightColor: { value: lightColor },
              lightDirection: { value: lightDirection },
              ambientLight: { value: ambientLight },
            },
            vertexShader: `
            varying vec2 vUv;
            varying vec3 vNormal;
            varying vec3 vPosition;
    
            void main() {
              vUv = uv;
              vNormal = normalMatrix * normal;
              vPosition = (modelViewMatrix * vec4(position, 1.0)).xyz;
              gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
          `,
            fragmentShader: `
      uniform vec3 material1Color;
      uniform float material1Metalness;
      uniform float material1Roughness;
      uniform float material1Opacity;
      uniform sampler2D material1NormalMap;
      uniform bool hasMaterial1NormalMap;
    
      uniform vec3 material2Color;
      uniform float material2Metalness;
      uniform float material2Roughness;
      uniform float material2Opacity;
      uniform sampler2D material2NormalMap;
      uniform bool hasMaterial2NormalMap;
    
      uniform sampler2D maskTexture;
      uniform samplerCube envMap;
    
      uniform vec3 lightColor;  // Light color (optional)
      uniform vec3 lightDirection;  // Directional light direction
      uniform vec3 ambientLight;  // Ambient light
    
      varying vec2 vUv;
      varying vec3 vNormal;
      varying vec3 vPosition;
    
      vec3 getReflection(vec3 color, float metalness, float roughness, vec3 normal) {
        vec3 viewDir = normalize(-vPosition);
        vec3 reflectDir = reflect(viewDir, normal);
        return textureCube(envMap, reflectDir).rgb * metalness * (1.0 - roughness);
      }
    
      vec3 applyNormalMap(sampler2D normalMap, vec3 defaultNormal) {
        vec3 normalTex = texture2D(normalMap, vUv).xyz * 2.0 - 1.0;
        return normalize(mix(defaultNormal, normalTex, length(normalTex)));
      }
    
      vec3 getDiffuseLighting(vec3 normal, vec3 lightDir, vec3 lightCol, vec3 ambientCol) {
        // Diffuse light calculation
        float diffuse = max(dot(normal, lightDir), 0.0);
        return lightCol * diffuse + ambientCol;  // Combine diffuse and ambient light
      }
    
      void main() {
        // Get grayscale value from mask texture
        vec4 mask = texture2D(maskTexture, vUv);
        float grayscale = dot(mask.rgb, vec3(0.299, 0.587, 0.114)); // Convert to grayscale
    
        // Blend colors, metalness, roughness, and opacity based on mask
        vec3 blendedColor = mix(material1Color, material2Color, grayscale);
        float blendedMetalness = mix(material1Metalness, material2Metalness, grayscale);
        float blendedRoughness = mix(material1Roughness, material2Roughness, grayscale);
        float blendedOpacity = mix(material1Opacity, material2Opacity, grayscale);
    
        // Default normal (from geometry)
        vec3 blendedNormal = normalize(vNormal);
    
        // Apply and blend normal maps
        if (hasMaterial1NormalMap && hasMaterial2NormalMap) {
          vec3 normal1 = texture2D(material1NormalMap, vUv).xyz * 2.0 - 1.0;
          vec3 normal2 = texture2D(material2NormalMap, vUv).xyz * 2.0 - 1.0;
          blendedNormal = normalize(mix(normal1, normal2, grayscale));
        } else if (hasMaterial1NormalMap) {
          vec3 normal1 = texture2D(material1NormalMap, vUv).xyz * 2.0 - 1.0;
          blendedNormal = normalize(mix(vNormal, normal1, grayscale));
        } else if (hasMaterial2NormalMap) {
          vec3 normal2 = texture2D(material2NormalMap, vUv).xyz * 2.0 - 1.0;
          blendedNormal = normalize(mix(vNormal, normal2, grayscale));
        }
    
        // Calculate diffuse lighting
        vec3 diffuseLighting = getDiffuseLighting(blendedNormal, normalize(lightDirection), lightColor, ambientLight);
    
        // Calculate environment reflection using the blended normal
        vec3 reflection = mix(
          getReflection(material1Color, material1Metalness, material1Roughness, blendedNormal),
          getReflection(material2Color, material2Metalness, material2Roughness, blendedNormal),
          grayscale
        );
    
        // Final output color with diffuse lighting, reflection, and transparency blending
        gl_FragColor = vec4((blendedColor * diffuseLighting) + reflection, blendedOpacity);
      }
    `,
            transparent: true,
          })

          if (g.children.length === 0) {
            // wrong case
          } else if (type === 'double') {
            // @ts-ignore
            g.children[0].material[4] = blendingMaterial
            // @ts-ignore
            g.children[0].needsUpdate = true
            // @ts-ignore
            g.children[1].material[4] = blendingMaterial
            // @ts-ignore
            g.children[1].needsUpdate = true
          } else {
            // @ts-ignore
            g.children[0].material[4] = blendingMaterial
            // @ts-ignore
            g.children[0].needsUpdate = true
          }

          // @ts-ignore
          if (window.renderScene) {
            // @ts-ignore
            window.renderScene()
          }
        }
      )
    }
  )

  return g
}

export const createDoorFivePieces = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  splitters: string,
  width: number,
  height: number,
  thickness: number,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  fivePiecesConfig: ConfigsType['fivePiecesConfig'],
  isForDrawer?: boolean,
  isForSmallDrawer?: boolean,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const g = new Group()

  const pieces = getNewDoorPiecesFromSplitters(splitters, height, 'cm')
  console.log(pieces)

  if (type === 'left' || type === 'right' || type === 'liftUp') {
    const fivePieces = new Group()

    const horizontalPieceWidth = isForSmallDrawer
      ? fivePiecesConfig.pieceWidth / 2
      : fivePiecesConfig.pieceWidth
    const verticalPieceWidth = fivePiecesConfig.pieceWidth

    const lTexture = texture.clone()
    lTexture.repeat.set(verticalPieceWidth / tLength, height / tWidth)
    lTexture.offset.x = Math.random()
    lTexture.needsUpdate = true

    const rTexture = texture.clone()
    rTexture.repeat.set(verticalPieceWidth / tLength, height / tWidth)
    rTexture.offset.x = Math.random()
    rTexture.needsUpdate = true

    const tTexture = texture.clone()
    tTexture.repeat.set(
      horizontalPieceWidth / tLength,
      (width - verticalPieceWidth * 2) / tWidth
    )
    tTexture.offset.x = Math.random()
    tTexture.needsUpdate = true

    const bTexture = texture.clone()
    bTexture.repeat.set(
      horizontalPieceWidth / tLength,
      (width - verticalPieceWidth * 2) / tWidth
    )
    bTexture.offset.x = Math.random()
    bTexture.needsUpdate = true

    const leftPiece = createSheet(
      verticalPieceWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: lTexture, ...threePropsObj })
    )
    const rightPiece = createSheet(
      verticalPieceWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: rTexture, ...threePropsObj })
    )

    const centerPieceWidth = width - verticalPieceWidth * 2
    const centerPieceHeight = height - horizontalPieceWidth * 2
    const centerPieceThickness =
      thickness - fivePiecesConfig.centerThicknessDelta

    const cTexture = texture.clone()
    cTexture.repeat.set(centerPieceWidth / tLength, centerPieceHeight / tWidth)
    cTexture.offset.x = Math.random()
    cTexture.needsUpdate = true

    // console.log(
    //   width,
    //   height,
    //   centerPieceWidth,
    //   centerPieceHeight,
    //   tWidth,
    //   tLength,
    //   cTexture.repeat
    // )
    console.log(height, centerPieceHeight, horizontalPieceWidth)
    let centerPiece = createSheet(
      centerPieceWidth,
      centerPieceHeight,
      centerPieceThickness,
      new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
    )

    if (isForDrawer) {
      cTexture.repeat.set(
        centerPieceHeight / tLength,
        centerPieceWidth / tWidth
      )
      cTexture.offset.x = Math.random()
      cTexture.needsUpdate = true

      centerPiece = createSheet(
        centerPieceHeight,
        centerPieceWidth,
        centerPieceThickness,
        new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
      )

      centerPiece.rotateZ(Math.PI / 2)
    }

    fivePieces.add(centerPiece)
    fivePieces.add(leftPiece)
    fivePieces.add(rightPiece)

    centerPiece.name = 'centerPiece'
    leftPiece.name = 'verticalPiece'
    rightPiece.name = 'verticalPiece'

    centerPiece.position.z = -centerPieceThickness / 2
    leftPiece.position.x = -(centerPieceWidth + verticalPieceWidth) / 2
    rightPiece.position.x = (centerPieceWidth + verticalPieceWidth) / 2

    leftPiece.rotateZ(Math.PI)

    const topPiece = createSheet(
      horizontalPieceWidth,
      width - verticalPieceWidth * 2,
      thickness,
      new MeshStandardMaterial({ map: tTexture, ...threePropsObj })
    )
    const bottomPiece = createSheet(
      horizontalPieceWidth,
      width - verticalPieceWidth * 2,
      thickness,
      new MeshStandardMaterial({ map: bTexture, ...threePropsObj })
    )

    topPiece.name = 'horizontalPiece'
    bottomPiece.name = 'horizontalPiece'

    fivePieces.add(topPiece)
    fivePieces.add(bottomPiece)
    topPiece.position.y = (centerPieceHeight + horizontalPieceWidth) / 2
    bottomPiece.position.y = -(centerPieceHeight + horizontalPieceWidth) / 2
    topPiece.rotateZ(-Math.PI / 2)
    bottomPiece.rotateZ(Math.PI / 2)

    const holeBoxDepth = 0.2

    if (!isForSmallDrawer && pieces.length === 1 && pieces[0].whole) {
      fivePieces.remove(centerPiece)
      const piece = pieces[0]
      const actualHoleHeight = height - fivePiecesConfig.pieceWidth * 2
      // if (piece.holeType !== 'none') {
      const matProps = getNewDoorHoleMaterialProps(splitters, true)

      const cTexture = texture.clone()
      cTexture.repeat.set(
        (width - fivePiecesConfig.pieceWidth * 2) / tLength,
        actualHoleHeight / tWidth
      )
      cTexture.offset.x = Math.random()
      cTexture.needsUpdate = true

      let centerGeo = new BoxGeometry(
        width - fivePiecesConfig.pieceWidth * 2,
        actualHoleHeight,
        holeBoxDepth
      )

      if (isForDrawer) {
        centerGeo = new BoxGeometry(
          actualHoleHeight,
          width - fivePiecesConfig.pieceWidth * 2,
          holeBoxDepth
        )

        centerGeo.rotateZ(Math.PI / 2)

        cTexture.repeat.set(
          actualHoleHeight / tLength,
          (width - fivePiecesConfig.pieceWidth * 2) / tWidth
        )
        cTexture.offset.x = Math.random()
        cTexture.needsUpdate = true
      }

      const hole = new Mesh(
        centerGeo,
        piece.holeType === 'none'
          ? new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
          : new MeshStandardMaterial({
              color: matProps.color,
              metalness: matProps.metalness,
              roughness: matProps.roughness,
              envMap: reflectionCubMap,
              transparent: true,
              opacity: matProps.opacity, // Fully transparent
            })
      )

      hole.position.z = -holeBoxDepth / 2 + 0.1
      hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

      fivePieces.add(hole)
      // }
    } else if (!isForSmallDrawer && pieces.length > 1) {
      let temp = (centerPieceHeight + fivePiecesConfig.pieceWidth * 2) / 2
      fivePieces.remove(centerPiece)
      for (let i = 0; i < pieces.length; i++) {
        const piece = [...pieces].reverse()[i]

        if (i !== pieces.length - 1) {
          const verticalCenterPiece = createSheet(
            fivePiecesConfig.pieceWidth,
            width - fivePiecesConfig.pieceWidth * 2,
            thickness,
            new MeshStandardMaterial({ map: tTexture, ...threePropsObj })
          )

          verticalCenterPiece.position.y = temp
          verticalCenterPiece.position.y -= piece.num
          temp = verticalCenterPiece.position.y

          verticalCenterPiece.rotateZ(-Math.PI / 2)

          verticalCenterPiece.name = 'horizontalPiece'
          fivePieces.add(verticalCenterPiece)
        }

        const actualHoleHeight =
          piece.num -
          fivePiecesConfig.pieceWidth *
            (i === 0 || i === pieces.length - 1 ? 1.5 : 1)
        const actualHoleWidth = width - fivePiecesConfig.pieceWidth * 2 //+ 30

        const cTexture = texture.clone()
        cTexture.repeat.set(
          actualHoleWidth / tLength,
          actualHoleHeight / tWidth
        )
        cTexture.offset.x = Math.random()
        cTexture.needsUpdate = true

        const matProps = getNewDoorHoleMaterialProps(splitters, true)

        const hole = new Mesh(
          new BoxGeometry(
            actualHoleWidth,
            actualHoleHeight,
            centerPieceThickness
          ),
          piece.holeType === 'none'
            ? new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
            : new MeshStandardMaterial({
                color: matProps.color,
                metalness: matProps.metalness,
                roughness: matProps.roughness,
                envMap: reflectionCubMap,
                transparent: true,
                opacity: matProps.opacity, // Fully transparent
              })
        )

        if (i !== pieces.length - 1) {
          hole.position.y =
            temp + (actualHoleHeight + fivePiecesConfig.pieceWidth) / 2
        } else {
          hole.position.y =
            temp -
            piece.num +
            actualHoleHeight / 2 +
            fivePiecesConfig.pieceWidth
        }
        hole.position.z = centerPiece.position.z // + 10.5
        hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

        fivePieces.add(hole)
      }
    }

    g.add(fivePieces)
  } else {
    const leftSheetWidth = width / 2 - doorConfig.verticalGap / 2
    const rightSheetWidth = width / 2 - doorConfig.verticalGap / 2

    const lFivePieces = new Group()
    const rFivePieces = new Group()

    const lTexture = texture.clone()
    lTexture.repeat.set(fivePiecesConfig.pieceWidth / tLength, height / tWidth)
    lTexture.offset.x = Math.random()
    lTexture.needsUpdate = true

    const rTexture = texture.clone()
    rTexture.repeat.set(fivePiecesConfig.pieceWidth / tLength, height / tWidth)
    rTexture.offset.x = Math.random()
    rTexture.needsUpdate = true

    const tTexture = texture.clone()
    tTexture.repeat.set(
      fivePiecesConfig.pieceWidth / tLength,
      (leftSheetWidth - fivePiecesConfig.pieceWidth * 2) / tWidth
    )
    tTexture.offset.x = Math.random()
    tTexture.needsUpdate = true

    const bTexture = texture.clone()
    bTexture.repeat.set(
      fivePiecesConfig.pieceWidth / tLength,
      (leftSheetWidth - fivePiecesConfig.pieceWidth * 2) / tWidth
    )
    bTexture.offset.x = Math.random()
    bTexture.needsUpdate = true

    const lLeftPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: lTexture, ...threePropsObj })
    )
    const lRightPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: rTexture, ...threePropsObj })
    )
    const lTopPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new MeshStandardMaterial({ map: tTexture, ...threePropsObj })
    )
    const lBottomPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new MeshStandardMaterial({ map: bTexture, ...threePropsObj })
    )

    const lCenterPieceWidth = leftSheetWidth - fivePiecesConfig.pieceWidth * 2
    const lCenterPieceHeight = height - fivePiecesConfig.pieceWidth * 2
    const lCenterPieceThickness =
      thickness - fivePiecesConfig.centerThicknessDelta

    const cTexture = texture.clone()
    cTexture.repeat.set(
      lCenterPieceWidth / tLength,
      lCenterPieceHeight / tWidth
    )
    cTexture.offset.x = Math.random()
    cTexture.needsUpdate = true

    const lCenterPiece = createSheet(
      lCenterPieceWidth,
      lCenterPieceHeight,
      lCenterPieceThickness,
      new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
    )

    lCenterPiece.name = 'centerPiece'
    lLeftPiece.name = 'verticalPiece'
    lRightPiece.name = 'verticalPiece'
    lTopPiece.name = 'horizontalPiece'
    lBottomPiece.name = 'horizontalPiece'

    lFivePieces.add(lCenterPiece)
    lFivePieces.add(lLeftPiece)
    lFivePieces.add(lRightPiece)
    lFivePieces.add(lTopPiece)
    lFivePieces.add(lBottomPiece)

    lCenterPiece.position.z = -lCenterPieceThickness / 2
    lLeftPiece.position.x =
      -(lCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    lRightPiece.position.x =
      (lCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    lTopPiece.position.y =
      (lCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2
    lBottomPiece.position.y =
      -(lCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2

    lLeftPiece.rotateZ(Math.PI)
    lTopPiece.rotateZ(-Math.PI / 2)
    lBottomPiece.rotateZ(Math.PI / 2)

    const rlTexture = lTexture.clone()
    const rrTexture = rTexture.clone()
    const rtTexture = tTexture.clone()
    const rbTexture = bTexture.clone()
    const rcTexture = bTexture.clone()
    rlTexture.offset.x = Math.random()
    rrTexture.offset.x = Math.random()
    rtTexture.offset.x = Math.random()
    rbTexture.offset.x = Math.random()
    rcTexture.offset.x = Math.random()
    rlTexture.needsUpdate = true
    rrTexture.needsUpdate = true
    rtTexture.needsUpdate = true
    rbTexture.needsUpdate = true
    rcTexture.needsUpdate = true

    const rLeftPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: rlTexture, ...threePropsObj })
    )
    const rRightPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: rrTexture, ...threePropsObj })
    )
    const rTopPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      rightSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new MeshStandardMaterial({ map: rtTexture, ...threePropsObj })
    )
    const rBottomPiece = createSheet(
      fivePiecesConfig.pieceWidth,
      rightSheetWidth - fivePiecesConfig.pieceWidth * 2,
      thickness,
      new MeshStandardMaterial({ map: rbTexture, ...threePropsObj })
    )

    const rCenterPieceWidth = rightSheetWidth - fivePiecesConfig.pieceWidth * 2
    const rCenterPieceHeight = height - fivePiecesConfig.pieceWidth * 2
    const rCenterPieceThickness =
      thickness - fivePiecesConfig.centerThicknessDelta
    const rCenterPiece = createSheet(
      rCenterPieceWidth,
      rCenterPieceHeight,
      rCenterPieceThickness,
      new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
    )

    rCenterPiece.name = 'centerPiece'
    rLeftPiece.name = 'verticalPiece'
    rRightPiece.name = 'verticalPiece'
    rTopPiece.name = 'horizontalPiece'
    rBottomPiece.name = 'horizontalPiece'

    rFivePieces.add(rCenterPiece)
    rFivePieces.add(rLeftPiece)
    rFivePieces.add(rRightPiece)
    rFivePieces.add(rTopPiece)
    rFivePieces.add(rBottomPiece)

    rCenterPiece.position.z = -rCenterPieceThickness / 2
    rLeftPiece.position.x =
      -(rCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    rRightPiece.position.x =
      (rCenterPieceWidth + fivePiecesConfig.pieceWidth) / 2
    rTopPiece.position.y =
      (rCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2
    rBottomPiece.position.y =
      -(rCenterPieceHeight + fivePiecesConfig.pieceWidth) / 2

    rLeftPiece.rotateZ(Math.PI)
    rTopPiece.rotateZ(-Math.PI / 2)
    rBottomPiece.rotateZ(Math.PI / 2)

    g.add(lFivePieces)
    g.add(rFivePieces)

    lFivePieces.position.x = -leftSheetWidth / 2 - doorConfig.verticalGap / 2
    rFivePieces.position.x = rightSheetWidth / 2 + doorConfig.verticalGap / 2

    // if (pieces.length > 1) {
    //   let temp = (lCenterPieceHeight + fivePiecesConfig.pieceWidth * 2) / 2
    //   for (let i = 0; i < pieces.length - 1; i++) {
    //     const piece = pieces[i]

    //     const lVerticalCenterPiece = createSheet(
    //       fivePiecesConfig.pieceWidth,
    //       leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
    //       thickness,
    //       new MeshStandardMaterial({ map: tTexture })
    //     )

    //     lVerticalCenterPiece.position.y = temp
    //     lVerticalCenterPiece.position.y -= piece.num

    //     const rVerticalCenterPiece = createSheet(
    //       fivePiecesConfig.pieceWidth,
    //       rightSheetWidth - fivePiecesConfig.pieceWidth * 2,
    //       thickness,
    //       new MeshStandardMaterial({ map: tTexture })
    //     )

    //     rVerticalCenterPiece.position.y = lVerticalCenterPiece.position.y

    //     temp = rVerticalCenterPiece.position.y

    //     // lVerticalCenterPiece.rotateZ(-Math.PI / 2)
    //     rVerticalCenterPiece.rotateZ(-Math.PI / 2)

    //     lVerticalCenterPiece.name = 'horizontalPiece123'
    //     rVerticalCenterPiece.name = 'horizontalPiece123'

    //     lFivePieces.add(lVerticalCenterPiece)
    //     rFivePieces.add(rVerticalCenterPiece)
    //   }
    // }

    const holeBoxDepth = 0.2

    if (pieces.length === 1 && pieces[0].whole) {
      lFivePieces.remove(lCenterPiece)
      rFivePieces.remove(rCenterPiece)

      const piece = pieces[0]
      const actualHoleHeight = height - fivePiecesConfig.pieceWidth * 2
      // if (piece.holeType !== 'none') {
      const matProps = getNewDoorHoleMaterialProps(splitters, true)

      const cTexture = texture.clone()
      cTexture.repeat.set(
        (leftSheetWidth - fivePiecesConfig.pieceWidth * 2) / tLength,
        actualHoleHeight / tWidth
      )
      cTexture.offset.x = Math.random()
      cTexture.needsUpdate = true

      const hole = new Mesh(
        new BoxGeometry(
          leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
          actualHoleHeight,
          holeBoxDepth
        ),
        piece.holeType === 'none'
          ? new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
          : new MeshStandardMaterial({
              color: matProps.color,
              metalness: matProps.metalness,
              roughness: matProps.roughness,
              envMap: reflectionCubMap,
              transparent: true,
              opacity: matProps.opacity, // Fully transparent
            })
      )

      hole.position.z = -holeBoxDepth / 2 + 0.1
      hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

      lFivePieces.add(hole)

      if (piece.holeType === 'none') {
        const rcTexture = cTexture.clone()
        rcTexture.offset.x = Math.random()
        rcTexture.needsUpdate = true

        const rHole = hole.clone()
        rHole.material = rHole.material.clone()
        rHole.material.map = rcTexture
        rHole.material.needsUpdate = true
        rFivePieces.add(rHole)
      } else {
        rFivePieces.add(hole.clone())
      }
      // }
    } else if (pieces.length > 1) {
      let temp = (lCenterPieceHeight + fivePiecesConfig.pieceWidth * 2) / 2
      lFivePieces.remove(lCenterPiece)
      rFivePieces.remove(rCenterPiece)
      for (let i = 0; i < pieces.length; i++) {
        const piece = [...pieces].reverse()[i]

        if (i !== pieces.length - 1) {
          const ltTexture = tTexture.clone()
          const rtTexture = tTexture.clone()
          ltTexture.offset.x = Math.random()
          ltTexture.needsUpdate = true
          rtTexture.offset.x = Math.random()
          rtTexture.needsUpdate = true

          const verticalCenterPiece = createSheet(
            fivePiecesConfig.pieceWidth,
            leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
            thickness,
            new MeshStandardMaterial({ map: ltTexture, ...threePropsObj })
          )
          const rVerticalCenterPiece = createSheet(
            fivePiecesConfig.pieceWidth,
            leftSheetWidth - fivePiecesConfig.pieceWidth * 2,
            thickness,
            new MeshStandardMaterial({ map: rtTexture, ...threePropsObj })
          )

          verticalCenterPiece.position.y = temp
          verticalCenterPiece.position.y -= piece.num
          temp = verticalCenterPiece.position.y

          verticalCenterPiece.rotateZ(-Math.PI / 2)

          verticalCenterPiece.name = 'horizontalPiece'

          rVerticalCenterPiece.position.x = verticalCenterPiece.position.x
          rVerticalCenterPiece.position.y = verticalCenterPiece.position.y
          rVerticalCenterPiece.position.z = verticalCenterPiece.position.z
          rVerticalCenterPiece.rotation.x = verticalCenterPiece.rotation.x
          rVerticalCenterPiece.rotation.y = verticalCenterPiece.rotation.y
          rVerticalCenterPiece.rotation.z = verticalCenterPiece.rotation.z
          rVerticalCenterPiece.name = 'horizontalPiece'

          lFivePieces.add(verticalCenterPiece)
          rFivePieces.add(rVerticalCenterPiece)
        }

        const actualHoleHeight =
          piece.num -
          fivePiecesConfig.pieceWidth *
            (i === 0 || i === pieces.length - 1 ? 1.5 : 1)
        const actualHoleWidth = leftSheetWidth - fivePiecesConfig.pieceWidth * 2 //+ 30

        const cTexture = texture.clone()
        cTexture.repeat.set(
          actualHoleWidth / tLength,
          actualHoleHeight / tWidth
        )
        cTexture.offset.x = Math.random()
        cTexture.needsUpdate = true

        const matProps = getNewDoorHoleMaterialProps(splitters, true)

        const hole = new Mesh(
          new BoxGeometry(
            actualHoleWidth,
            actualHoleHeight,
            lCenterPieceThickness
          ),
          piece.holeType === 'none'
            ? new MeshStandardMaterial({ map: cTexture, ...threePropsObj })
            : new MeshStandardMaterial({
                color: matProps.color,
                metalness: matProps.metalness,
                roughness: matProps.roughness,
                envMap: reflectionCubMap,
                transparent: true,
                opacity: matProps.opacity, // Fully transparent
              })
        )

        if (i !== pieces.length - 1) {
          hole.position.y =
            temp + (actualHoleHeight + fivePiecesConfig.pieceWidth) / 2
        } else {
          hole.position.y =
            temp -
            piece.num +
            actualHoleHeight / 2 +
            fivePiecesConfig.pieceWidth
        }
        hole.position.z = lCenterPiece.position.z // + 10.5
        hole.name = piece.holeType === 'none' ? 'centerPiece' : 'hole'

        lFivePieces.add(hole)

        if (piece.holeType === 'none') {
          const rcTexture = cTexture.clone()
          rcTexture.offset.x = Math.random()
          rcTexture.needsUpdate = true

          const rHole = hole.clone()
          rHole.material = rHole.material.clone()
          rHole.material.map = rcTexture
          rHole.material.needsUpdate = true
          rFivePieces.add(rHole)
        } else {
          rFivePieces.add(hole.clone())
        }
      }
    }
  }
  return g
}

export const createShakerDoor = (
  type: 'left' | 'right' | 'double' | 'liftUp',
  isVertical: boolean,
  width: number,
  height: number,
  thickness: number,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  doorConfig: ConfigsType['doorConfig'],
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const g = new Group()

  if (type === 'double') {
    const leftSheetWidth = width / 2 - doorConfig.verticalGap / 2
    const rightSheetWidth = width / 2 - doorConfig.verticalGap / 2

    const lNewTexture = texture.clone()
    const rNewTexture = texture.clone()

    lNewTexture.wrapS = RepeatWrapping
    lNewTexture.wrapT = RepeatWrapping
    lNewTexture.offset.x = Math.random()
    rNewTexture.wrapS = RepeatWrapping
    rNewTexture.wrapT = RepeatWrapping
    rNewTexture.offset.x = Math.random()

    if (!isVertical) {
      lNewTexture.rotation = Math.PI / 2
      lNewTexture.repeat.set(height / tLength, leftSheetWidth / tWidth)

      rNewTexture.rotation = Math.PI / 2
      rNewTexture.repeat.set(height / tLength, rightSheetWidth / tWidth)
    } else {
      lNewTexture.repeat.set(height / tLength, leftSheetWidth / tWidth)
      rNewTexture.repeat.set(height / tLength, rightSheetWidth / tWidth)
    }
    lNewTexture.needsUpdate = true
    rNewTexture.needsUpdate = true

    const leftSheet = createSheet(
      leftSheetWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: lNewTexture, ...threePropsObj })
    )

    const rightSheet = createSheet(
      rightSheetWidth,
      height,
      thickness,
      new MeshStandardMaterial({ map: rNewTexture, ...threePropsObj })
    )

    g.add(leftSheet)
    g.add(rightSheet)

    // leftSheet.rotateX(Math.PI / 2)
    // rightSheet.rotateX(Math.PI / 2)

    leftSheet.position.x = -leftSheetWidth / 2 - doorConfig.verticalGap / 2
    rightSheet.position.x = rightSheetWidth / 2 + doorConfig.verticalGap / 2

    // leftSheet.position.x -= leftSheetWidth / 2
    // rightSheet.position.x -= rightSheetWidth / 2
    // leftSheet.position.y += height / 2
    // rightSheet.position.y += height / 2
    // leftSheet.position.z -= thickness / 2
    // rightSheet.position.z -= thickness / 2
  } else {
    const newTexture = texture.clone()
    newTexture.wrapS = RepeatWrapping
    newTexture.wrapT = RepeatWrapping
    newTexture.offset.x = Math.random()

    if (!isVertical) {
      newTexture.rotation = Math.PI / 2
      newTexture.repeat.set(height / tLength, width / tWidth)
      // console.log(width, height, tLength, tWidth, newTexture.repeat)
    } else {
      newTexture.repeat.set(width / tLength, height / tWidth)
    }
    newTexture.needsUpdate = true

    const sheet = createSheet(
      width,
      height,
      thickness,
      new MeshStandardMaterial({ map: newTexture, ...threePropsObj })
    )

    g.add(sheet)
  }
  return g
}

export const createDrawer = (
  visualType: DrawerVisualType,
  width: number,
  height: number,
  depth: number,
  boxWidth: number,
  boxHeight: number,
  boxDepth: number,
  thickness: number,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  boxTexture: Texture = new Texture(),
  btLength: number,
  btWidth: number,
  drawerConfig: ConfigsType['drawerConfig'],
  doorConfig: ConfigsType['doorConfig'],
  fivePiecesConfig: ConfigsType['fivePiecesConfig'],
  threeProps?: string
) => {
  const g = new Group()

  const drawerMaxHeight = 7.25 * 2.54

  let isSmall = false

  if (height < drawerMaxHeight) {
    isSmall = true
  }

  const sheet =
    visualType === 'fivePieces'
      ? createDoorFivePieces(
          'left',
          '',
          width,
          height,
          thickness,
          texture,
          tLength,
          tWidth,
          doorConfig,
          fivePiecesConfig,
          true,
          isSmall,
          threeProps
        )
      : visualType.startsWith('#')
      ? createNewDoors(
          'left',
          visualType as DoorNewVisualTypes,
          '',
          width,
          height,
          thickness,
          texture,
          tLength,
          tWidth,
          // @ts-ignore
          drawerConfig,
          true,
          threeProps
        )
      : visualType.startsWith('shaker')
      ? createShakerDoor(
          'left',
          visualType === 'shaker_v',
          width,
          height,
          thickness,
          texture,
          tLength,
          tWidth,
          doorConfig
        )
      : createSheet(
          width,
          height,
          thickness,
          new MeshStandardMaterial({ map: texture })
        )

  g.add(sheet)

  const boxSheetThickness = drawerConfig.boxSheetThickness

  const backFrontTexture = boxTexture.clone()
  backFrontTexture.repeat.set(boxWidth / btLength, boxHeight / btWidth)
  backFrontTexture.needsUpdate = true

  const boxBackSheet = createSheet(
    boxWidth,
    boxHeight,
    boxSheetThickness,
    new MeshStandardMaterial({ map: backFrontTexture })
  )

  const boxFrontSheet = createSheet(
    boxWidth,
    boxHeight,
    boxSheetThickness,
    new MeshStandardMaterial({ map: backFrontTexture })
  )

  const bottomTexture = boxTexture.clone()
  bottomTexture.repeat.set(boxWidth / btLength, boxDepth / btWidth)
  bottomTexture.needsUpdate = true

  const boxBottomSheet = createSheet(
    boxWidth,
    boxSheetThickness,
    boxDepth - boxSheetThickness * 2,
    new MeshStandardMaterial({ map: bottomTexture })
  )

  const sideTexture = boxTexture.clone()
  sideTexture.repeat.set(boxDepth / btLength, boxHeight / btWidth)
  sideTexture.needsUpdate = true

  const boxLeftSheet = createSheet(
    boxSheetThickness,
    boxHeight,
    boxDepth - boxSheetThickness * 2,
    new MeshStandardMaterial({ map: sideTexture })
  )

  const boxRightSheet = createSheet(
    boxSheetThickness,
    boxHeight,
    boxDepth - boxSheetThickness * 2,
    new MeshStandardMaterial({ map: sideTexture })
  )

  g.add(boxBackSheet)
  g.add(boxFrontSheet)
  g.add(boxLeftSheet)
  g.add(boxRightSheet)
  g.add(boxBottomSheet)

  boxFrontSheet.position.z = -thickness / 2 - boxSheetThickness / 2
  boxBackSheet.position.z = -thickness / 2 - boxDepth + boxSheetThickness / 2
  boxBottomSheet.position.set(
    0,
    (-boxHeight + boxSheetThickness) / 2,
    -thickness / 2 - boxDepth / 2
  )
  boxLeftSheet.position.set(
    (-boxWidth + boxSheetThickness) / 2,
    0,
    -thickness / 2 - boxDepth / 2
  )
  boxRightSheet.position.set(
    (boxWidth - boxSheetThickness) / 2,
    0,
    -thickness / 2 - boxDepth / 2
  )

  for (let i = 1; i < 6; i++) {
    g.children[i].position.y -= height / 2
    g.children[i].position.y += boxHeight / 2
    g.children[i].position.y += drawerConfig.boxHeightBottomMargin
  }

  return g
}

const createStandardLeg = (
  height: number,
  standardLegConfig: ConfigsType['standardLegConfig'],
  material: Material = new MeshBasicMaterial({ color: 'black' })
) => {
  const leg = new Group()

  const box = new Mesh(
    new BoxGeometry(
      standardLegConfig.boxLength,
      standardLegConfig.boxHeight,
      standardLegConfig.boxWidth
    ),
    material
  )

  const littleCylinderHeight =
    height - standardLegConfig.boxHeight - standardLegConfig.bigCylinderHeight

  const littleCylinder = new Mesh(
    new CylinderGeometry(
      standardLegConfig.littleCylinderRadius,
      standardLegConfig.littleCylinderRadius,
      littleCylinderHeight,
      24
    ),
    material
  )

  const bigCylinder = new Mesh(
    new CylinderGeometry(
      standardLegConfig.bigCylinderRadius,
      standardLegConfig.bigCylinderRadius,
      standardLegConfig.bigCylinderHeight,
      24
    ),
    material
  )

  leg.add(box)
  leg.add(littleCylinder)
  leg.add(bigCylinder)

  box.position.y -= standardLegConfig.boxHeight / 2
  littleCylinder.position.y -=
    standardLegConfig.boxHeight + littleCylinderHeight / 2
  bigCylinder.position.y -=
    standardLegConfig.boxHeight +
    littleCylinderHeight +
    standardLegConfig.bigCylinderHeight / 2

  return leg
}

export const createStandard2Leg = (
  subType: 'short' | 'tall',
  height: number,
  standard2LegConfig: ConfigsType['standard2LegConfig'],
  material: Material = new MeshBasicMaterial({ color: 'black' })
) => {
  const leg = new Group()

  const box = new Mesh(
    new BoxGeometry(
      standard2LegConfig.boxLength,
      standard2LegConfig.boxHeight,
      standard2LegConfig.boxWidth
    ),
    material
  )

  const bigCylinderHeight =
    subType === 'tall'
      ? standard2LegConfig.bigCylinderHeightTall
      : standard2LegConfig.bigCylinderHeight

  const littleCylinderHeight =
    height -
    standard2LegConfig.boxHeight -
    bigCylinderHeight -
    standard2LegConfig.separateLayerHeight

  const littleCylinder = new Mesh(
    new CylinderGeometry(
      standard2LegConfig.littleCylinderRadius,
      standard2LegConfig.littleCylinderRadius,
      littleCylinderHeight,
      24
    ),
    material
  )

  const bigCylinder = new Mesh(
    new CylinderGeometry(
      standard2LegConfig.bigCylinderRadius,
      standard2LegConfig.bigCylinderRadius,
      bigCylinderHeight,
      24
    ),
    material
  )

  const separateCylinder = new Mesh(
    new CylinderGeometry(
      standard2LegConfig.separateLayerRadius,
      standard2LegConfig.separateLayerRadius,
      standard2LegConfig.separateLayerHeight,
      24
    ),
    material
  )

  const littleSeparateCylinder = new Mesh(
    new CylinderGeometry(
      standard2LegConfig.littleSeparateLayerRadius,
      standard2LegConfig.littleSeparateLayerRadius,
      standard2LegConfig.littleSeparateLayerHeight,
      24
    ),
    material
  )

  leg.add(box)
  leg.add(bigCylinder)
  leg.add(separateCylinder)
  leg.add(littleCylinder)
  leg.add(littleSeparateCylinder)

  box.position.y -= standard2LegConfig.boxHeight / 2
  bigCylinder.position.y -= standard2LegConfig.boxHeight + bigCylinderHeight / 2
  separateCylinder.position.y -=
    standard2LegConfig.boxHeight +
    bigCylinderHeight +
    standard2LegConfig.separateLayerHeight / 2

  littleCylinder.position.y -=
    standard2LegConfig.boxHeight +
    bigCylinderHeight +
    standard2LegConfig.separateLayerHeight +
    littleCylinderHeight / 2
  littleSeparateCylinder.position.y -=
    standard2LegConfig.boxHeight +
    bigCylinderHeight +
    standard2LegConfig.separateLayerHeight +
    littleCylinderHeight -
    standard2LegConfig.littleSeparateLayerPosFromBottom

  return leg
}

export const createStandardLegs = (
  height: number,
  cabinetWidth: number,
  cabinetDepth: number,
  standardLegConfig: ConfigsType['standardLegConfig'],
  material: Material = new MeshBasicMaterial({ color: 'black' })
) => {
  const g = new Group()

  for (let i = 0; i < 4; i++) {
    g.add(createStandardLeg(height, standardLegConfig, material))
  }

  g.children[0].position.x =
    -cabinetWidth / 2 +
    standardLegConfig.sideReveal +
    standardLegConfig.boxLength / 2
  g.children[0].position.z =
    cabinetDepth / 2 -
    standardLegConfig.frontReveal -
    standardLegConfig.boxLength / 2

  g.children[1].position.x =
    -cabinetWidth / 2 +
    standardLegConfig.sideReveal +
    standardLegConfig.boxLength / 2
  g.children[1].position.z =
    -cabinetDepth / 2 +
    standardLegConfig.backReveal +
    standardLegConfig.boxLength / 2

  g.children[2].position.x =
    cabinetWidth / 2 -
    standardLegConfig.sideReveal -
    standardLegConfig.boxLength / 2
  g.children[2].position.z =
    -cabinetDepth / 2 +
    standardLegConfig.backReveal +
    standardLegConfig.boxLength / 2

  g.children[3].position.x =
    cabinetWidth / 2 -
    standardLegConfig.sideReveal -
    standardLegConfig.boxLength / 2
  g.children[3].position.z =
    cabinetDepth / 2 -
    standardLegConfig.frontReveal -
    standardLegConfig.boxLength / 2

  return g
}

export const createStandard2Legs = (
  subType: 'short' | 'tall',
  height: number,
  cabinetWidth: number,
  cabinetDepth: number,
  standard2LegConfig: ConfigsType['standard2LegConfig'],
  material: Material = new MeshBasicMaterial({ color: 'black' })
) => {
  const g = new Group()

  for (let i = 0; i < 4; i++) {
    g.add(createStandard2Leg(subType, height, standard2LegConfig, material))
  }

  g.children[0].position.x =
    -cabinetWidth / 2 +
    standard2LegConfig.sideReveal +
    standard2LegConfig.boxLength / 2
  g.children[0].position.z =
    cabinetDepth / 2 -
    standard2LegConfig.frontReveal -
    standard2LegConfig.boxLength / 2

  g.children[1].position.x =
    -cabinetWidth / 2 +
    standard2LegConfig.sideReveal +
    standard2LegConfig.boxLength / 2
  g.children[1].position.z =
    -cabinetDepth / 2 +
    standard2LegConfig.backReveal +
    standard2LegConfig.boxLength / 2

  g.children[2].position.x =
    cabinetWidth / 2 -
    standard2LegConfig.sideReveal -
    standard2LegConfig.boxLength / 2
  g.children[2].position.z =
    -cabinetDepth / 2 +
    standard2LegConfig.backReveal +
    standard2LegConfig.boxLength / 2

  g.children[3].position.x =
    cabinetWidth / 2 -
    standard2LegConfig.sideReveal -
    standard2LegConfig.boxLength / 2
  g.children[3].position.z =
    cabinetDepth / 2 -
    standard2LegConfig.frontReveal -
    standard2LegConfig.boxLength / 2

  return g
}

export const createSplittedTop = (
  cabinetWidth: number,
  cabinetDepth: number,
  sheetWidth: number,
  thickness: number,
  material: Material | Material[] = new MeshNormalMaterial()
) => {
  const g = new Group()

  const sheet1 = createSheet(sheetWidth, thickness, cabinetWidth, material)
  const sheet2 = createSheet(sheetWidth, thickness, cabinetWidth, material)

  g.add(sheet1)
  g.add(sheet2)

  sheet1.position.z = (cabinetDepth - sheetWidth) / 2
  sheet1.rotation.y = Math.PI / 2
  sheet2.position.z = -(cabinetDepth - sheetWidth) / 2
  sheet2.rotation.y = Math.PI / 2

  return g
}

export const createSeparateBasePlatform = (
  width: number,
  depth: number,
  height: number,
  texture = new Texture(),
  tLength: number,
  tWidth: number,
  separateBaseConfig: ConfigsType['separateBaseConfig']
) => {
  const thickness = separateBaseConfig.sheetThickness
  const g = new Group()

  const backFrontTexture = texture.clone()
  backFrontTexture.repeat.set(width / tLength, height / tWidth)
  backFrontTexture.needsUpdate = true

  const backSheet = createSheet(
    width,
    height,
    thickness,
    new MeshStandardMaterial({ map: backFrontTexture })
  )

  const frontSheet = createSheet(
    width,
    height,
    thickness,
    new MeshStandardMaterial({ map: backFrontTexture })
  )

  const sideTexture = texture.clone()
  sideTexture.repeat.set(depth / tLength, height / tWidth)
  sideTexture.needsUpdate = true

  const leftSheet = createSheet(
    depth - 2 * thickness,
    height,
    thickness,
    new MeshStandardMaterial({ map: sideTexture })
  )

  const centerSheet = createSheet(
    depth - 2 * thickness,
    height,
    thickness,
    new MeshStandardMaterial({ map: sideTexture })
  )

  const rightSheet = createSheet(
    depth - 2 * thickness,
    height,
    thickness,
    new MeshStandardMaterial({ map: sideTexture })
  )

  g.add(backSheet)
  g.add(frontSheet)
  g.add(leftSheet)
  g.add(centerSheet)
  g.add(rightSheet)

  leftSheet.rotation.y = Math.PI / 2
  centerSheet.rotation.y = Math.PI / 2
  rightSheet.rotation.y = Math.PI / 2

  leftSheet.position.x = (thickness - width) / 2
  rightSheet.position.x = (-thickness + width) / 2

  backSheet.position.z = (thickness - depth) / 2
  frontSheet.position.z = (-thickness + depth) / 2

  leftSheet.position.z -= separateBaseConfig.frontMargin / 2
  rightSheet.position.z -= separateBaseConfig.frontMargin / 2
  centerSheet.position.z -= separateBaseConfig.frontMargin / 2
  backSheet.position.z -= separateBaseConfig.frontMargin / 2
  frontSheet.position.z -= separateBaseConfig.frontMargin / 2

  return g
}

export const createCornerHorizontalSheet = (
  type: '2door' | 'angled',
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  backWidth1: number,
  backWidth2: number,
  thickness: number,
  temp: boolean,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  isPewter = false
) => {
  const extrudeSettings = {
    steps: 1,
    depth: thickness,
    bevelEnabled: false,
    bevelThickness: 0.05,
    bevelSize: 0.05,
    bevelOffset: -0.1,
    bevelSegments: 1,
  }
  // https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing
  // const e1 = width1 - backWidth1 - thickness //old backWidth calculation, some calculations can be useless now, but for fast reaching result algorithm not been changed
  const e1 = backWidth1 - thickness
  const e2 = backWidth2 - thickness
  const hyp = (e1 ** 2 + e2 ** 2) ** 0.5
  const x1 = (thickness * hyp) / e2
  const x2 = (thickness * hyp) / e1
  // const g = new Group()

  const shape = new Shape()

  shape.moveTo(backWidth2 + x2, thickness)
  shape.lineTo(width2 - thickness, thickness)
  shape.lineTo(width2 - thickness, depth2)

  if (type === '2door') shape.lineTo(depth1, depth2)

  shape.lineTo(depth1, width1 - thickness)
  shape.lineTo(thickness, width1 - thickness)
  shape.lineTo(thickness, backWidth1 + x1)

  const geometry = new ExtrudeGeometry(shape, extrudeSettings)

  const newTexture = texture.clone()
  newTexture.wrapS = RepeatWrapping
  newTexture.wrapT = RepeatWrapping
  newTexture.repeat.set(1, tLength / tWidth)
  newTexture.rotation = Math.PI / 4
  newTexture.needsUpdate = true

  if (!temp) {
    applyBoxUV(
      geometry,
      new Matrix4().fromArray([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      tLength
    )

    geometry.attributes.uv.needsUpdate = true
  }

  const material = new MeshStandardMaterial({ map: newTexture })
  const bMat = new MeshBasicMaterial({ color: 'black' })

  const mesh = new Mesh(
    geometry,
    temp ? new MeshNormalMaterial() : isPewter ? [material, bMat] : material
  )

  // mesh.rotation.x = Math.PI / 2

  // g.add(mesh)

  return mesh //origin of object is not in center because it is  extruded shape
}

export const createCornerTwoDoor = (
  visualType: DoorVisualType,
  splitters: string,
  type: CornerTwoDoorItemPropsType['subType'],
  width1: number,
  width2: number,
  height: number,
  thickness: number,
  texture: Texture = new Texture(),
  tLength: number,
  tWidth: number,
  configs: ConfigsType,
  threeProps?: string
) => {
  const threePropsObj = safeDecodeAndParse(threeProps)

  const g = new Group()
  console.log(visualType)

  if (type === 'right') {
    const panelTexture = texture.clone()
    panelTexture.repeat.set(width2 / tLength, height / tWidth)
    panelTexture.needsUpdate = true

    let firstPanel = new Object3D()
    let secondPanel = new Object3D()

    if (visualType === 'vGroove') {
      firstPanel = createDoorVGroove(
        type,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.vGrooveConfig,
        threeProps
      ).children[0] as Mesh
      secondPanel = createSheet(
        width2,
        height,
        thickness,
        new MeshStandardMaterial({ map: panelTexture, ...threePropsObj })
      )

      firstPanel.rotateZ(-Math.PI / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
      firstPanel.position.set(
        -width2 / 2 - thickness / 2,
        height / 2,
        width1 + thickness - (width1 / 2 + thickness / 2)
      )
    } else if (visualType === 'fivePieces') {
      firstPanel = createDoorFivePieces(
        type,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      ).children[0] as Mesh
      secondPanel = createDoorFivePieces(
        type,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    } else if (visualType.startsWith('#')) {
      firstPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )
      secondPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )

      firstPanel.rotateY(Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    } else if (visualType.startsWith('shaker')) {
      firstPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      ).children[0] as Mesh
      secondPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    }

    g.add(firstPanel)
    g.add(secondPanel)
  } else {
    const panelTexture = texture.clone()
    panelTexture.repeat.set(width1 / tLength, height / tWidth)
    panelTexture.needsUpdate = true

    let firstPanel = new Object3D()
    let secondPanel = new Object3D()

    if (visualType === 'vGroove') {
      firstPanel = createSheet(
        width1,
        height,
        thickness,
        new MeshStandardMaterial({ map: panelTexture, ...threePropsObj })
      )
      secondPanel = createDoorVGroove(
        type,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.vGrooveConfig,
        threeProps
      ).children[0] as Mesh

      firstPanel.rotateY(-Math.PI / 2)

      firstPanel.position.set(-width2 / 2, 0, thickness / 2)
      secondPanel.position.x += thickness / 2
      secondPanel.position.z -= width1 / 2
    } else if (visualType === 'fivePieces') {
      firstPanel = createDoorFivePieces(
        type,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      ).children[0] as Mesh
      secondPanel = createDoorFivePieces(
        type,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        configs.fivePiecesConfig,
        false,
        false,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    } else if (visualType.startsWith('#')) {
      firstPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )
      secondPanel = createNewDoors(
        type,
        visualType as DoorNewVisualTypes,
        splitters,
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        false,
        threeProps
      )
      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
      g.add(secondPanel)

      firstPanel.rotateY(Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)
    } else if (visualType.startsWith('shaker')) {
      firstPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width1,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      ).children[0] as Mesh
      secondPanel = createShakerDoor(
        type,
        visualType === 'shaker_v',
        width2,
        height,
        thickness,
        texture,
        tLength,
        tWidth,
        configs.doorConfig,
        threeProps
      )

      firstPanel.rotateY(-Math.PI / 2)
      firstPanel.position.set(-width2 / 2, 0, thickness / 2)

      secondPanel.position.set(thickness / 2, 0, -(width1 / 2))
    }

    g.add(firstPanel)
    g.add(secondPanel)
  }
  return g
}

export const createCornerLegs = (
  height: number,
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  backWidth1: number,
  backWidth2: number,
  thickness: number,
  standardLegConfig: ConfigsType['standardLegConfig'],
  material: Material = new MeshBasicMaterial({ color: 'black' })
) => {
  const g = new Group()

  for (let i = 0; i < 7; i++) {
    g.add(createStandardLeg(height, standardLegConfig, material))
  }

  const e1 = backWidth1 - thickness //edge
  const e2 = backWidth2 - thickness
  // const hyp = (e1 ** 2 + e2 ** 2) ** .5 //hypotenuse

  // const x1 = (thickness) * hyp / e2
  // const x2 = (thickness) * hyp / e1

  g.children[0].position.x =
    thickness + e2 + 0.5026 + standardLegConfig.boxLength / 2
  g.children[0].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[1].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[1].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[2].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[2].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[3].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[3].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[4].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[4].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[5].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[5].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[6].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[6].position.z = thickness + e1 + standardLegConfig.boxWidth / 2

  return g
}

export const createCornerLegs2 = (
  subType: 'short' | 'tall',
  height: number,
  width1: number,
  width2: number,
  depth1: number,
  depth2: number,
  backWidth1: number,
  backWidth2: number,
  thickness: number,
  standardLegConfig: ConfigsType['standard2LegConfig'],
  material: Material = new MeshBasicMaterial({ color: 'black' })
) => {
  const g = new Group()

  for (let i = 0; i < 7; i++) {
    g.add(createStandard2Leg(subType, height, standardLegConfig, material))
  }

  const e1 = backWidth1 - thickness //edge
  const e2 = backWidth2 - thickness
  // const hyp = (e1 ** 2 + e2 ** 2) ** .5 //hypotenuse

  // const x1 = (thickness) * hyp / e2
  // const x2 = (thickness) * hyp / e1

  g.children[0].position.x =
    thickness + e2 + 0.5026 + standardLegConfig.boxLength / 2
  g.children[0].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[1].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[1].position.z = 0.692124 + standardLegConfig.boxWidth / 2

  g.children[2].position.x = width2 - 0.605 - standardLegConfig.boxLength / 2
  g.children[2].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[3].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[3].position.z = depth2 - 0.5026 - standardLegConfig.boxWidth / 2

  g.children[4].position.x = depth1 - 0.5026 - standardLegConfig.boxLength / 2
  g.children[4].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[5].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[5].position.z = width1 - 0.605 - standardLegConfig.boxWidth / 2

  g.children[6].position.x = 0.692124 + standardLegConfig.boxLength / 2
  g.children[6].position.z = thickness + e1 + standardLegConfig.boxWidth / 2

  return g
}
